<ion-content class="container">
    <ion-row *ngIf="!router.url.includes('Setup') && !router.url.includes('unlocksystem')">
        <ion-col [attr.size-lg]="userIsAdmin?7:11" class="pl-15 pr-0 pb-0">
            <div class="borderbottomForTab">
                <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
                    (selectedTabChange)="tabTypeChanged($event)">
                    <mat-tab label="Dashboard">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    speed
                                </span>Dashboard</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Employee Goals" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
            || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' || loggedInUserRole == 'Admin'">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    group
                                </span>Employee Goals</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="My Goals" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee'
            || loggedInUserRole == 'HOD'">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    ads_click
                                </span>My Goals</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Team Goals" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    group
                                </span>Team Goals</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Dotted Goals" *ngIf="(loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Employee')
                    && loggedInUserisDottedManager">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    lan
                                </span>Dotted Goals</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Dept KPIs" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    lan
                                </span>Dept KPIs</span>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Reports">
                        <ng-template mat-tab-label>
                            <span style="display: contents;">
                                <span class="material-icons mr-10">
                                    description
                                </span>Reports</span>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </ion-col>
        <ion-col [attr.size-lg]="userIsAdmin?5:1" class="borderbottomForTab pl-10 pt-10 pr-10"
            *ngIf="!router.url.includes('Setup') && !router.url.includes('unlocksystem') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <button type="button" class="add_btn fs-14 float-right center-content"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
            <button (click)="onClickImport()" type="button" class="importGoalBtn float-right fs-14 mr-10">Import
                Goals</button>
            <button type="button" class="add_btn fs-14 float-right center-content mr-10"
                [style.background-color]="buttonColorName" (click)="onClickSetup('unlocksystem')">
                <span class="material-icons fs-20 mr-5">settings</span>Unlock System</button>
        </ion-col>
        <ion-col [attr.size-lg]="userIsAdmin?5:1"
            class="center-content d-flex justify-content-flex-end borderbottomForTab pl-10 pt-10 pr-10"
            *ngIf="!router.url.includes('Setup') && !router.url.includes('unlocksystem') && (loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD')">
            <div class="icon-container">
                <span class="material-icons mr-10 fs-16 icon">info</span>
                <div class="tooltip">
                    <div class="">
                        <form [formGroup]="pmsSetupInformationForm">
                            <ion-row>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                                    <div class="font_bold fs-14">PMS Settings</div>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">Fiscal Year:&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{sharedService.transform(pmsSetupInformationForm.value.fiscalYear)}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">Year:&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{sharedService.transformYearToFyFormat(pmsSetupInformationForm.value.year)}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">Review Cycle:&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{pmsSetupInformationForm.value.reviewCycle}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">Goal Setting at all levels:&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{pmsSetupInformationForm.value.goalSettingAtllLevels ? 'Yes': 'NA'}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">Cutoff Date:&nbsp;</span>
                                    <span class="formLabelBoldfs12"
                                        *ngIf="!pmsSetupInformationForm.value.cutoffDateApplicable">
                                        {{pmsSetupInformationForm.value.cutoffDateApplicable ? 'Yes': 'NA'}}
                                    </span>
                                    <span class="formLabelBoldfs12"
                                        *ngIf="pmsSetupInformationForm.value.cutoffDateApplicable">
                                        {{pmsSetupInformationForm.value.cutoffDate}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5"
                                    *ngIf="pmsSetupInformationForm.value.cutoffDateApplicable">
                                    <span class="formLabelRegularfs12 mb-5">Grace Period (day):&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{pmsSetupInformationForm.value.gracePeriod}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">CFT Member:&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{pmsSetupInformationForm.value.cftValue ? 'Yes': 'NA'}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
                                    <span class="formLabelRegularfs12 mb-5">Cap Value:&nbsp;</span>
                                    <span class="formLabelBoldfs12" *ngIf="!pmsSetupInformationForm.value.capValue">
                                        {{pmsSetupInformationForm.value.capValue ? 'Yes': 'NA'}}
                                    </span>
                                    <span class="formLabelBoldfs12" *ngIf="pmsSetupInformationForm.value.capValue">
                                        {{pmsSetupInformationForm.value.capSelect}}
                                        ({{pmsSetupInformationForm.value.valueSelect=='Monthly_Cut_off'?'Monthly
                                        Cap':'YTD Cap'}})
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5"
                                    *ngIf="pmsSetupInformationForm.value.capSelect == 'Straight' && pmsSetupInformationForm.value.capValue == true">
                                    <span class="formLabelRegularfs12 mb-5">Straight Value:&nbsp;</span>
                                    <span class="formLabelBoldfs12">
                                        {{pmsSetupInformationForm.value.comment}}
                                    </span>
                                </ion-col>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5"
                                    *ngIf="pmsSetupInformationForm.value.capSelect == 'Range' && pmsSetupInformationForm.value.capValue == true">
                                    <span class="formLabelBoldfs12 mb-5">Range&nbsp;</span>
                                    <ion-row>
                                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                                            <ion-row class="p-0">
                                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                                    class="p-0 tableBorder brtopLeft8 tableBg text-center">
                                                    <div class="formLabelSemiBoldfs12">Range for Score</div>
                                                    <div class="formLabelSemiBoldfs12">Normalization</div>
                                                </ion-col>
                                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                                    class="p-0 tableBorder brtopRight8 tableBg text-center">
                                                    <div class="formLabelSemiBoldfs12 p-10">Normalize Score</div>
                                                </ion-col>
                                            </ion-row>
                                            <ion-row class="p-0" *ngFor="let data of addedScores;let i=index">
                                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                                    class="tableBorder text-center">
                                                    <div class="formLabelRegularfs14 p-10">
                                                        <span *ngIf="data.minRange!=0">></span>{{data.minRange}} -
                                                        {{data.maxRange}}
                                                    </div>
                                                </ion-col>
                                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                                    class="tableBorder text-center">
                                                    <div class="formLabelRegularfs14 p-10">
                                                        {{data.normalizeScore}}</div>
                                                </ion-col>
                                            </ion-row>
                                        </ion-col>
                                    </ion-row>
                                </ion-col>


                            </ion-row>
                        </form>
                    </div>
                </div>
            </div>
        </ion-col>
    </ion-row>


    <div class="container"
        *ngIf="selectedTypeTabName == 'Dashboard' && !router.url.includes('Setup') && !router.url.includes('unlocksystem')">
        <ion-row class="mt-10">
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                <div class="d-flex center-content">
                    <img src="././assets/icon/cutOff.svg">&nbsp;<span class="font_semibold fs-14">Cut-Off Date:&nbsp;
                        <span class="formLabelBoldfs12" *ngIf="!pmsSetupInformationForm.value.cutoffDateApplicable">
                            {{pmsSetupInformationForm.value.cutoffDateApplicable ? 'Yes': 'NA'}}
                        </span>
                        <span class="formLabelBoldfs12" *ngIf="pmsSetupInformationForm.value.cutoffDateApplicable">
                            {{pmsSetupInformationForm.value.cutoffDate}}
                        </span>
                    </span>&nbsp;|&nbsp;
                    <img src="././assets/icon/capValue.svg">&nbsp;<span class="font_semibold fs-14">Grace Period
                        (day):&nbsp;
                        <span class="formLabelBoldfs12">
                            {{pmsSetupInformationForm.value.cutoffDateApplicable?pmsSetupInformationForm.value.gracePeriod:'NA'}}
                        </span>
                    </span>
                </div>
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="d-flex justify-content-flex-end">
                <div class="d-flex center-content">
                    <ng-select class="w150" [clearable]="false" placeholder="Select"
                        [(ngModel)]="selectedYear" (change)="chnageSelectYearDashboard()">
                        <ng-option [value]="item.year"
                            *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                    </ng-select>
                    <ng-select class="w150 ml-15" [clearable]="false" placeholder="Select"
                        [(ngModel)]="fromDateGloabalDashboard" (change)="formMonthChangeDashboard()">
                        <ng-option [value]="item"
                            *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                    </ng-select>
                    <!-- <div>
                        <img (click)="gloablDashboardDownload()" class="cp ml-10 h35" src="././assets/icon/downloadIcon.svg">
                    </div> -->
                </div>
            </ion-col>
        </ion-row>
        <!-- counter module -->
        <div class="clear20"></div>
        <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6" *ngFor="let item of dashboardCounterModule">
                <ion-row class="countercardBox cp text-left" (click)="onClickCard(item.ModuleName)">
                    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                        <img class="counterIcon" src="{{item.moduleActiveIcon}}"
                            [ngStyle]="{'background': item?.background ? item.background : 'red' }">
                    </ion-col>
                    <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
                        <div class="font_semibold fs-14 black_color">
                            {{item.ModuleName}}
                        </div>
                        <div class="font_bold mt-10 black_color ml-30"
                            [ngStyle]="{'color': item?.color ? item.color : 'red' }">
                            {{item.totalCount}}</div>
                    </ion-col>
                </ion-row>
            </ion-col>
        </ion-row>

        <div class="clear20"></div>
        <ion-row>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                <div class="dashboardTablecardBox MaxHeight550px">
                    <ion-row>
                        <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8">
                            <div class="font_bold fs-16 black_color">{{sharedService.transform(loggedInCompanyReviewCycle)}} vs YTD Score</div>
                        </ion-col>
                        <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                            <div class="d-flex graph-icon">
                                <span (click)="onClickQuarterlyTable()" class="cp">
                                    <img src="././assets/icon/activeTable.svg" *ngIf="hideQuarterlyTable">
                                    <img src="././assets/icon/tableIcon.svg" *ngIf="!hideQuarterlyTable">
                                </span>
                                <span (click)="setChartTypeQuaterlyytdScoreChart('bar')" class="cp">
                                    <img src="././assets/icon/activeBarChart.svg"
                                        *ngIf="quaterlyytdScoreChartGraphType=='bar'">
                                    <img src="././assets/icon/barChartIcon.svg"
                                        *ngIf="quaterlyytdScoreChartGraphType!='bar'">
                                </span>
                                <span  (click)="setChartTypeQuaterlyytdScoreChart('line')" class="cp">
                                    <img src="././assets/icon/activeLineChart.svg"
                                        *ngIf="quaterlyytdScoreChartGraphType=='line'">
                                    <img src="././assets/icon/lineChartIcon.svg"
                                        *ngIf="quaterlyytdScoreChartGraphType!='line'">
                                </span>
                                <span class="cp" (click)="pmsDashboardGraphDownloadReviewCycleVsYTD()">
                                    <img src="././assets/icon/downloadIcon.svg">
                                </span>
                            </div>
                        </ion-col>
                    </ion-row>
                    <div class="d-flex">
                        <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select Year" [(ngModel)]="selectedYearTtdTable"
                                (selectionChange)="chnageSelectYearDashboardYtdTable()">
                                <mat-option [value]="item.year"
                                    *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w150 ml-10 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="fromDateYtdTable"
                                (selectionChange)="formMonthChangeDashboardYtdTable()">
                                <mat-option [value]="item"
                                    *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            [ngClass]="{'dispNone' : !hideQuarterlyTable}" id="quaterlyytdscorechartTable">
                            <div>
                                <table>
                                    <tr>
                                        <th class="fs-14 font_bold">Employee Name</th>
                                        <th class="fs-14 font_bold">{{revirewCycleName}} Wise</th>
                                        <th class="fs-14 font_bold">Till Date YTD Wise</th>
                                    </tr>
                                    <tr *ngFor="let item of quarterlyBarChartData">
                                        <td class="fs-14 font_regular">{{item?.name}}</td>
                                        <td class="fs-14 font_regular">{{item?.quarterWise || null}}</td>
                                        <td class="fs-14 font_regular">{{item?.yearWise || null}}</td>
                                    </tr>
                                </table>
                            </div>
                        </ion-col>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            [ngClass]="{'dispNone' : hideQuarterlyTable}">
                            <div id="quaterlyytdscorechart" style="width: 500px; height: 400px;"></div>
                        </ion-col>
                    </ion-row>
                </div>
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                <div class="dashboardTablecardBox MaxHeight550px">
                    <ion-row>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div class="font_bold fs-16 black_color">KPI Score Summary</div>
                        </ion-col>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div class="d-flex graph-icon">
                                <!-- <span (click)="setChartType('line')">
                                    <img src="././assets/icon/activeLineChart.svg"
                                        *ngIf="kpiScoreSummaryGraphType=='line'">
                                    <img src="././assets/icon/lineChartIcon.svg"
                                        *ngIf="kpiScoreSummaryGraphType!='line'">
                                </span> -->
                                <span (click)="onClickKpiScoreTable()">
                                    <img src="././assets/icon/activeTable.svg" *ngIf="showKpiScoreTableChart">
                                    <img src="././assets/icon/tableIcon.svg" *ngIf="!showKpiScoreTableChart">
                                </span>
                                <span (click)="setChartType('bar')">
                                    <img src="././assets/icon/activeBarChart.svg" *ngIf="kpiScoreSummaryGraphType=='bar'">
                                    <img src="././assets/icon/barChartIcon.svg" *ngIf="kpiScoreSummaryGraphType!='bar'">
                                </span>
                                <span (click)="setChartType('pie')">
                                    <img src="././assets/icon/activePieChartIcon.svg"
                                        *ngIf="kpiScoreSummaryGraphType=='pie'">
                                    <img src="././assets/icon/pieChartIcon.svg" *ngIf="kpiScoreSummaryGraphType!='pie'">
                                </span>
                                <span class="cp" (click)="pmsDashboardGraphDownloadKPIScoreSummary()">
                                    <img src="././assets/icon/downloadIcon.svg">
                                </span>
                            </div>
                        </ion-col>
                    </ion-row>
                    <div class="d-flex">
                        <ng-select class="w150" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                            [(ngModel)]="selectedKpiScoreSummaryYear" (change)="KpiScoreSummaryYearchange()">
                            <ng-option [value]="item.year"
                                *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                        </ng-select>
                        <ng-select class="w150 ml-10" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                            [(ngModel)]="selectedKpiScoreSummaryfromDate" (change)="KpiScoreSummaryformMonthChange()">
                            <ng-option [value]="item"
                                *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                        </ng-select>
                        <ng-select *ngIf="loggedInUserRole != 'Employee'" class="w250 ml-10" dropdownPosition="bottom" [clearable]="false"
                            placeholder="Select Employee" [(ngModel)]="selectedKpiUser" (change)="getKpiGoalSummary()">
                            <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                            <ng-option *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
                            || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && loggedInCompanyMDID!=null" [value]="loggedInCompanyMDID">My Chart</ng-option>
                            <ng-option [value]="item.id" *ngFor="let item of teamOfManagerListForKPISummary">{{item.name}}</ng-option>
                        </ng-select>
                    </div>

                    <ion-row [ngClass]="{'dispNone' : !showKpiScoreTableChart}" id="KPIScoreSummaryTable">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                            <div class="table-container">
                                <table>
                                    <tr>
                                        <th class="fs-14 font_bold">Score</th>
                                        <th class="fs-14 font_bold">No. of Employees</th>
                                        <th class="fs-14 font_bold">%ge of the Population</th>
                                    </tr>
                                    <tr *ngFor="let item of kpiGoalSummaryData">
                                        <td class="fs-14 font_regular">{{item?.name}}</td>
                                        <td class="fs-14 font_regular">{{item?.numberOfEmployees}}</td>
                                        <td class="fs-14 font_regular">{{item?.value}}</td>
                                    </tr>
                                </table>
                            </div>
                        </ion-col>
                    </ion-row>

                    <ion-row [ngClass]="{'dispNone' : showKpiScoreTableChart}">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                            <div id="chart" style="width: 500px; height: 400px;"></div>
                            <!-- <div [ngClass]="{'dispNone':kpiScoreSummaryGraphType!='pie'}" id="chart" style="width: 500px; height: 400px;"></div> -->
                        </ion-col>
                    </ion-row>
                </div>
            </ion-col>
        </ion-row>

        <div class="clear20"></div>
        <ion-row>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                <div class="dashboardTablecardBox MaxHeight580px">
                    <ion-row>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div class="font_bold fs-16 black_color">Target vs Actual</div>
                        </ion-col>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div class="d-flex graph-icon">
                                <span (click)="onClickTargetTable()" class="cp">
                                    <img src="././assets/icon/tableIcon.svg" *ngIf="!showTargetTable">
                                    <img src="././assets/icon/activeTable.svg" *ngIf="showTargetTable">
                                </span>
                                <span (click)="setChartTypeTargetvsActual('bar')" class="cp">
                                    <img src="././assets/icon/barChartIcon.svg" *ngIf="targetvsActualGraphType!='bar'">
                                    <img src="././assets/icon/activeBarChart.svg" *ngIf="targetvsActualGraphType=='bar'">
                                </span>
                                <span  (click)="setChartTypeTargetvsActual('line')" class="cp">
                                    <img src="././assets/icon/lineChartIcon.svg" *ngIf="targetvsActualGraphType!='line'">
                                    <img src="././assets/icon/activeLineChart.svg" *ngIf="targetvsActualGraphType=='line'">
                                </span>
                                <!-- <span class="cp"
                                (click)="setChartTypeTargetvsActual('pie')">
                                <img src="././assets/icon/pieChartIcon.svg" *ngIf="targetvsActualGraphType!='pie'">
                                <img src="././assets/icon/activePieChartIcon.svg" *ngIf="targetvsActualGraphType=='pie'">
                                </span> -->
                                <span  (click)="setChartTypeTargetvsActual('area')" class="cp">
                                    <img src="././assets/icon/area.svg" *ngIf="targetvsActualGraphType!='area'">
                                    <img src="././assets/icon/areaChart.svg" *ngIf="targetvsActualGraphType=='area'">
                                </span>
                                <span (click)="pmsDashboardGraphDownloadTargetVsActual()" class="cp">
                                    <img src="././assets/icon/downloadIcon.svg">
                                </span>
                            </div>
                        </ion-col>
                    </ion-row>
                    <div class="d-flex">
                        <mat-form-field class="w100 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="selectedYearTargetVsActual"
                                (selectionChange)="chnageSelectedYearTargetVsActual()">
                                <mat-option [value]="item.year"
                                    *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <ng-select *ngIf="loggedInUserRole != 'Employee'" class="w150 ml-10" dropdownPosition="bottom" [clearable]="false"
                            placeholder="Select Employee" [(ngModel)]="selectedKpiUserForTargetVsActual"
                            (change)="getTargetVsActualUsersList()">
                            <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                            <ng-option *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
                            || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && loggedInCompanyMDID!=null" [value]="loggedInCompanyMDID">My Chart</ng-option>
                            <ng-option [value]="item.id" *ngFor="let item of teamOfManagerListForTargetVSActual">{{item.name}}</ng-option>
                        </ng-select>
                        <ng-select class="w150 ml-10" dropdownPosition="bottom" [clearable]="false" placeholder="Select KPI"
                            [(ngModel)]="selectedKpi" (change)="getTargetVsActualDetails()">
                            <ng-option [value]="item.id" *ngFor="let item of kpiUsersList">{{item.kpi}}</ng-option>
                        </ng-select>
                    </div>
                    <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                            <div class="inputBoxDisabled1 opacity5">
                            {{selectedUom}}
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            [ngClass]="{'dispNone' : !showTargetTable}" id="targetVsActualTable">
                            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                                <div class="table-container">
                                    <table>
                                        <tr>
                                            <th class="fs-14 font_bold">Month</th>
                                            <th class="fs-14 font_bold">Target</th>
                                            <th class="fs-14 font_bold">Actual</th>
                                            <th class="fs-14 font_bold">Milestone</th>
                                        </tr>
                                        <tr *ngFor="let item of targetVsActualChartData">
                                            <td class="fs-14 font_regular">{{sharedService.transform(item?.month)}}</td>
                                            <td class="fs-14 font_regular">{{item?.target}}</td>
                                            <td class="fs-14 font_regular">{{item?.actual}}</td>
                                            <td class="fs-14 font_regular">{{sharedService.transform(toProperCase(item?.milestoneFrom))}}-{{sharedService.transform(toProperCase(item?.milestoneTo))}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </ion-col>
                        </ion-col>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" [ngClass]="{'dispNone' : showTargetTable}">
                            <div id="targetvsActual" style="width: 500px; height: 400px;"></div>
                        </ion-col>
                    </ion-row>
                    <div>
                        <span class="fs-12 font_semibold">Milestone Months:</span>
                        <span class="fs-12 font_semibold" *ngFor="let item of mileStoneMonth;let isLast=last">
                            <span *ngIf="item!=null">
                                {{item}} {{isLast ? ' ' : ', '}}
                            </span>
                        </span>
                    </div>
                </div>
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                <div class="dashboardTablecardBox MaxHeight580px">
                    <ion-row>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div class="font_bold fs-16 black_color">Previous 3 Years Data</div>
                        </ion-col>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
                            <div class="d-flex graph-icon">
                                <span (click)="onClicklastThreeYearKpiScoreTable()" class="cp">
                                    <img src="././assets/icon/tableIcon.svg" *ngIf="!showlastThreeYearKpiScoreTable">
                                    <img src="././assets/icon/activeTable.svg" *ngIf="showlastThreeYearKpiScoreTable">
                                </span>
                                <span  class="cp" (click)="setChartTypelastThreeYearKpiScore('bar')">
                                <img src="././assets/icon/barChartIcon.svg"
                                    *ngIf="lastThreeYearKpiScoreGraphType!='bar'">
                                <img src="././assets/icon/activeBarChart.svg"
                                    *ngIf="lastThreeYearKpiScoreGraphType=='bar'">
                                </span>
                                <span  class="cp" (click)="setChartTypelastThreeYearKpiScore('line')">
                                <img src="././assets/icon/lineChartIcon.svg"
                                    *ngIf="lastThreeYearKpiScoreGraphType!='line'">
                                <img src="././assets/icon/activeLineChart.svg"
                                    *ngIf="lastThreeYearKpiScoreGraphType=='line'">
                                </span>
                                <span class="cp"
                                (click)="setChartTypelastThreeYearKpiScore('pie')">
                                <img src="././assets/icon/pieChartIcon.svg"
                                    *ngIf="lastThreeYearKpiScoreGraphType!='pie'">
                                <img src="././assets/icon/activePieChartIcon.svg"
                                    *ngIf="lastThreeYearKpiScoreGraphType=='pie'">
                                </span>
                                <span (click)="setChartTypelastThreeYearKpiScore('area')" class="cp">
                                    <img src="././assets/icon/area.svg" *ngIf="lastThreeYearKpiScoreGraphType!='area'">
                                    <img src="././assets/icon/areaChart.svg"
                                        *ngIf="lastThreeYearKpiScoreGraphType=='area'">
                                </span>
                                <span class="cp" (click)="pmsDashboardGraphDownloadPrevious3YearsData()">
                                    <img src="././assets/icon/downloadIcon.svg">
                                </span>
                            </div>
                        </ion-col>
                    </ion-row>


                    <div class="d-flex">
                        <ng-select class="w150" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                            [(ngModel)]="selectedlastThreeYearKpiScoreKpiYear" (change)="changegetTeamOfManagerForPreviousThreeYearData()">
                            <ng-option [value]="item.year"
                                *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                        </ng-select>
                        <ng-select *ngIf="loggedInUserRole != 'Employee'" class="w250 ml-10" dropdownPosition="bottom" [clearable]="false"
                            placeholder="Select Employee" [(ngModel)]="selectedUserForlastThreeYearKpiScoreKpi"
                            (change)="lastThreeYearKpiScoreGraph();">
                            <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                            <ng-option *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
                            || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && loggedInCompanyMDID!=null" [value]="loggedInCompanyMDID">My Chart</ng-option>
                            <ng-option [value]="item.id" *ngFor="let item of teamOfManagerListForPreviousThreeYearData">{{item.name}}</ng-option>
                        </ng-select>
                    </div>
                    <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            [ngClass]="{'dispNone' : showlastThreeYearKpiScoreTable}">
                            <div id="lastThreeYearKpiScore" style="width: 500px; height: 400px;"></div>
                        </ion-col>

                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            [ngClass]="{'dispNone' : !showlastThreeYearKpiScoreTable}" class="cp" id="lastThreeYearKpiScoreTable">
                            <ion-row>
                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                    style="border-right: 1px solid #F3820E;">
                                    <div class="table-container">
                                        <table>
                                            <tr>
                                                <th class="fs-14 font_bold">Year</th>
                                                <th class="fs-14 font_bold">KPI Score</th>
                                            </tr>
                                            <tr *ngFor="let item of lastThreeYearDataForGraphKpi">
                                                <td class="fs-14 font_regular">{{item?.name}}</td>
                                                <td class="fs-14 font_regular">{{item?.value}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                    </ion-row>
                </div>
            </ion-col>
        </ion-row>

        <div class="clear20"></div>
        <div class="dashboardTablecardBox">
            <ion-row>
                <ion-col size-sm="11" size-md="11" size-lg="11" size-xs="11">
                    <div class="font_bold fs-16 black_color">Score Trend</div>
                </ion-col>
                <ion-col size-sm="1" size-md="1" size-lg="1" size-xs="1" class="text-right">
                    <img src="././assets/icon/downloadIcon.svg" (click)="pmsDashboardGraphDownloadScoreTrend('trendtable')">
                </ion-col>
            </ion-row>

            <div class="d-flex">
                <mat-form-field class="w150 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompanyScoreTrend"
                        (selectionChange)="compnayScoreCard()">
                        <mat-option [value]="item.year"
                            *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="fs-14 font_regular text_orange p-0 mt-10 cp ml-10" *ngIf="!showMangerTable"
                    (click)="onClickBack()">Back /&nbsp;<span
                        class="fs-14 font_bold  font_black p-0 mt-10 cp">{{managerName}}</span></div>
            </div>

            <ion-row>
                <ion-col>
                    <div class="table-container" *ngIf="showMangerTable">
                        <table id="trendtable">
                            <tr>
                                <th class="fs-12 font_bold">Name</th>
                                <th class="fs-12 font_bold">View Report</th>
                                <th *ngFor="let item of companyScoreMonths" class="fs-12 font_semibold">
                                    {{sharedService.transform(item?.months)}}
                                </th>
                                <th class="fs-12 font_bold">YTD</th>
                            </tr>
                            <tr *ngFor="let item of managerData;let i = index;">
                                <td class="fs-12 font_regular text_orange cp"
                                [ngClass]="{'text_orange' : !item.isEmployee}" (click)="onClickManagerData(item)">{{item?.managerName}}</td>
                                <td><img src="././assets/icon/blueEyeIcon.svg" class="cp"
                                        (click)="onClickEyeIcon(item)"></td>
                                <td *ngFor="let month of companyScoreMonths" class="fs-12 font_regular">
                                    {{ getKpiScoreForMonth(item.kpiScores, month.months) }}
                                </td>
                                <!-- <td *ngFor="let data of kpiScoreData" class="fs-12 font_regular">{{data?.kpiScore}}</td> -->
                                <td class="fs-12 font_regular">{{item?.ytdScore}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="table-container" *ngIf="!showMangerTable">
                        <table id="trendtable">
                            <tr>
                                <th class="fs-12 font_bold">Name</th>
                                <th class="fs-12 font_bold">View Report</th>
                                <th *ngFor="let item of companyScoreMonths" class="fs-12 font_bold">
                                    {{sharedService.transform(item?.months)}}
                                </th>
                                <th class="fs-12 font_bold">YTD</th>
                            </tr>
                            <tr *ngFor="let employee of employeeData; let i = index;">
                                <td (click)="onClickManagerData(employee)"
                                [ngClass]="{'text_orange' : !employee.isEmployee}"
                                    class="fs-12 font_regular cp">{{ employee.managerName
                                    }}
                                </td>
                                <td><img src="././assets/icon/blueEyeIcon.svg" class="cp"
                                        (click)="onClickEmployeeEyeIcon(employee)"></td>
                                <td *ngFor="let month of companyScoreMonths" class="fs-12 font_regular">
                                    {{ getKpiScoreForMonth(employee.kpiScores, month.months) }}
                                </td>
                                <td class="fs-12 font_regular">{{ employee.ytdScore }}</td>
                            </tr>
                        </table>
                    </div>
                </ion-col>
            </ion-row>
        </div>

        <div class="clear20"></div>
        <div class="dashboardTablecardBox">
            <ion-row>
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <ion-row>
                        <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
                            <div class="font_bold fs-16 black_color">Performing KPIs</div>
                        </ion-col>
                        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="p-0 text-right">
                            <div class="d-flex graph-icon">
                                <span (click)="onClickPeformingTable()" class="cp">
                                    <img src="././assets/icon/tableIcon.svg" *ngIf="!showPerformingTable">
                                    <img src="././assets/icon/activeTable.svg" *ngIf="showPerformingTable">
                                </span>
                                <span  class="cp"
                                (click)="setChartTypePerfomanceOfKpi('bar')">
                                <img src="././assets/icon/barChartIcon.svg" *ngIf="perfomanceOfKpiGraphType!='bar'">
                                <img src="././assets/icon/activeBarChart.svg"
                                    *ngIf="perfomanceOfKpiGraphType=='bar'">
                                </span>
                                <span class="cp"
                                (click)="setChartTypePerfomanceOfKpi('line')">
                                <img src="././assets/icon/lineChartIcon.svg"
                                    *ngIf="perfomanceOfKpiGraphType!='line'">
                                <img src="././assets/icon/activeLineChart.svg"
                                    *ngIf="perfomanceOfKpiGraphType=='line'">
                                </span>

                                <!-- <span (click)="onClickPeformingTable()"class="cp"
                                (click)="setChartTypePerfomanceOfKpi('pie')">
                                <img src="././assets/icon/pieChartIcon.svg" *ngIf="perfomanceOfKpiGraphType!='pie'">
                                <img src="././assets/icon/activePieChartIcon.svg"
                                    *ngIf="perfomanceOfKpiGraphType=='pie'">
                                </span> -->
                                <span class="cp"
                                (click)="setChartTypePerfomanceOfKpi('area')">
                                    <img src="././assets/icon/area.svg" *ngIf="perfomanceOfKpiGraphType!='area'">
                                    <img src="././assets/icon/areaChart.svg" *ngIf="perfomanceOfKpiGraphType=='area'">
                                </span>
                                <span class="cp" (click)="pmsDashboardGraphDownloadTopAndBottomPerformingKPIs()">
                                    <img src="././assets/icon/downloadIcon.svg">
                                </span>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            
            <div id="showPerformingGraph">
            <div class="d-flex">
                <ng-select class="w150" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                    [(ngModel)]="selectedPerformingKpiYear" (change)="chnagePerformingKpiYear()">
                    <ng-option [value]="item.year"
                        *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                </ng-select>
                <ng-select class="w150 ml-10" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                    [(ngModel)]="selectedPerformingKpifromDate" (change)="changeMonthOfPerformingKpi()">
                    <ng-option [value]="item"
                        *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                </ng-select>
                <ng-select *ngIf="loggedInUserRole != 'Employee'" class="w250 ml-10" dropdownPosition="bottom" [clearable]="false"
                    placeholder="Select Employee" [(ngModel)]="selectedPerformingKpiUser"
                    (change)="getTopPerformingKpiData();getBottomPerformingKpiData()">
                    <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                    <ng-option *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
                    || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && loggedInCompanyMDID!=null" [value]="loggedInCompanyMDID">My Chart</ng-option>
                    <ng-option [value]="item.id" *ngFor="let item of teamOfManagerListForPerformingKPI">{{item.name}}</ng-option>
                </ng-select>
            </div>
            <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="font_bold fs-16 black_color p-10">Top Kpi Score</div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="font_bold fs-16 black_color p-10">Bottom Kpi Score</div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                    [ngClass]="{'dispNone' : showPerformingTable}">
                    <ion-row>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div id="topPerfomanceOfKpi"
                                style="width: 500px; height: 400px; border-right: 1px solid #F3820E;"></div>
                        </ion-col>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div id="bottomPerfomanceOfKpi" style="width: 500px; height: 400px;"></div>
                        </ion-col>
                    </ion-row>
                </ion-col>

                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                    [ngClass]="{'dispNone' : !showPerformingTable}" class="cp" id="topPerfomanceOfKpiTable">
                    <ion-row>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                            style="border-right: 1px solid #F3820E;">
                            <div class="table-container">
                                <table>
                                    <tr>
                                        <th class="fs-14 font_bold">KPI</th>
                                        <th class="fs-14 font_bold">KPI Score</th>
                                    </tr>
                                    <tr *ngFor="let item of topPerformingKpiData">
                                        <td class="fs-14 font_regular">{{item?.kpi}}</td>
                                        <td class="fs-14 font_regular">{{item?.kpiScore}}</td>
                                    </tr>
                                </table>
                            </div>
                        </ion-col>
                        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                            <div class="table-container">
                                <table>
                                    <tr>
                                        <th class="fs-14 font_bold">KPI</th>
                                        <th class="fs-14 font_bold">KPI Score</th>
                                    </tr>
                                    <tr *ngFor="let item of bottomPerformingKpiData">
                                        <td class="fs-14 font_regular">{{item?.kpi}}</td>
                                        <td class="fs-14 font_regular">{{item?.kpiScore}}</td>
                                    </tr>
                                </table>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </div>
        </div>

        <div class="clear20"></div>
        <div class="dashboardTablecardBox">
            <ion-row>
                <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
                    <div class="font_bold fs-16 black_color">Top 4 KPIs Basis Weightage</div>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                    <div class="d-flex graph-icon">
                        <span class="cp"
                        (click)="onClickTopTenKpiTable('Table')">
                        <img src="././assets/icon/tableIcon.svg" *ngIf="!showTopTenKpiTable">
                        <img src="././assets/icon/activeTable.svg" *ngIf="showTopTenKpiTable">
                        </span>
                        <span class="cp"
                        (click)="setChartTypeTopTenKpis('bar')">
                        <img src="././assets/icon/barChartIcon.svg" *ngIf="topTenKpiChartGraphType!='bar'">
                        <img src="././assets/icon/activeBarChart.svg" *ngIf="topTenKpiChartGraphType=='bar'">
                        </span>
                        <span class="cp"
                        (click)="setChartTypeTopTenKpis('line')">
                        <img src="././assets/icon/lineChartIcon.svg" *ngIf="topTenKpiChartGraphType!='line'">
                        <img src="././assets/icon/activeLineChart.svg" *ngIf="topTenKpiChartGraphType=='line'">
                        </span>
                        <!-- <span class="cp"
                        (click)="setChartTypeTopTenKpis('pie')">
                        <img src="././assets/icon/pieChartIcon.svg" *ngIf="topTenKpiChartGraphType!='pie'">
                        <img src="././assets/icon/activePieChartIcon.svg" *ngIf="topTenKpiChartGraphType=='pie'">
                        </span> -->
                        <span class="cp"
                        (click)="setChartTypeTopTenKpis('area')">
                            <img src="././assets/icon/area.svg" *ngIf="topTenKpiChartGraphType!='area'">
                            <img src="././assets/icon/areaChart.svg" *ngIf="topTenKpiChartGraphType=='area'">
                        </span>
                        <span class="cp" (click)="pmsDashboardGraphDownloadTop4KPIsBasisWeightage()">
                            <img src="././assets/icon/downloadIcon.svg">
                        </span>
                    </div>
                </ion-col>
            </ion-row>
            <div>
            <div class="d-flex">
                <mat-form-field class="w150 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForTopTenKpi"
                        (selectionChange)="chnageSelectYearForTopTenKpi()">
                        <mat-option [value]="item.year"
                            *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-select class="w250 ml-10" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                    [(ngModel)]="fromDateForTopTenKpi" (change)="changeMonthOfTopTenKpi()">
                    <ng-option [value]="item"
                        *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                </ng-select>
                <ng-select class="w250 ml-10" dropdownPosition="bottom" [clearable]="false" placeholder="Select"
                    [(ngModel)]="selectedUserForTopTenKpi" (change)="getTopTenKpis()" *ngIf="loggedInUserRole != 'Employee'">
                    <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                    <ng-option *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
                    || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && loggedInCompanyMDID!=null" [value]="loggedInCompanyMDID">My Chart</ng-option>
                    <ng-option [value]="item.id" *ngFor="let item of teamOfManagerListForTopFourKPI">{{item.name}}</ng-option>
                </ng-select>
            </div>

           <div id="top4KPIsBasisWeightageGraph">
            <ion-row [ngClass]="{'dispNone' : !showTopTenKpiTable}">
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="table-container">
                        <table id="topfourKPI" *ngFor="let item of graphsForTopFirstKPIs">
                            <thead>
                                <tr>
                                    <th class="fs-14 font_bold" colspan="4">{{item.title}}</th>
                                </tr>
                                <tr>
                                    <th class="fs-14 font_bold">{{selectedYearReviewCycle}} %ge achievement</th>
                                    <th class="fs-14 font_bold">KPI score</th>
                                    <th class="fs-14 font_bold">YTD %ge Achievement</th>
                                    <th class="fs-14 font_bold">YTD KPI score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="fs-14 font_regular">{{item.target[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.target[1]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[1]}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="table-container">
                        <table id="topfourKPI" *ngFor="let item of graphsForTopSecondKPIs">
                            <thead>
                                <tr>
                                    <th class="fs-14 font_bold" colspan="4">{{item.title}}</th>
                                </tr>
                                <tr>
                                    <th class="fs-14 font_bold">{{selectedYearReviewCycle}} %ge achievement</th>
                                    <th class="fs-14 font_bold">KPI score</th>
                                    <th class="fs-14 font_bold">YTD %ge Achievement</th>
                                    <th class="fs-14 font_bold">YTD KPI score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="fs-14 font_regular">{{item.target[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.target[1]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[1]}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="table-container">
                        <table id="topfourKPI" *ngFor="let item of graphsForTopThirdKPIs">
                            <thead>
                                <tr>
                                    <th class="fs-14 font_bold" colspan="4">{{item.title}}</th>
                                </tr>
                                <tr>
                                    <th class="fs-14 font_bold">{{selectedYearReviewCycle}} %ge achievement</th>
                                    <th class="fs-14 font_bold">KPI score</th>
                                    <th class="fs-14 font_bold">YTD %ge Achievement</th>
                                    <th class="fs-14 font_bold">YTD KPI score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="fs-14 font_regular">{{item.target[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.target[1]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[1]}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="table-container">
                        <table id="topfourKPI" *ngFor="let item of graphsForTopFourthKPIs">
                            <thead>
                                <tr>
                                    <th class="fs-14 font_bold" colspan="4">{{item.title}}</th>
                                </tr>
                                <tr>
                                    <th class="fs-14 font_bold">{{selectedYearReviewCycle}} %ge achievement</th>
                                    <th class="fs-14 font_bold">KPI score</th>
                                    <th class="fs-14 font_bold">YTD %ge Achievement</th>
                                    <th class="fs-14 font_bold">YTD KPI score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="fs-14 font_regular">{{item.target[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[0]}}</td>
                                    <td class="fs-14 font_regular">{{item.target[1]}}</td>
                                    <td class="fs-14 font_regular">{{item.actual[1]}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ion-col>
            </ion-row>


            <ion-row [ngClass]="{'dispNone' : showTopTenKpiTable}">
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div id="topOnePerfomanceOfKpi" style="width: 500px; height: 400px;"></div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div id="topSecondPerfomanceOfKpi" style="width: 500px; height: 400px;"></div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div id="topthrirdPerfomanceOfKpi" style="width: 500px; height: 400px;"></div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div id="topFourthPerfomanceOfKpi" style="width: 500px; height: 400px;"></div>
                </ion-col>
            </ion-row>
           </div>

        </div>
        </div>
        <div class="clear20"></div>
    </div>

    <!-- --------------------------------------Goals--------------------------------- -->

    <div class="container mb-50"
        *ngIf="selectedTypeTabName == 'My Goals' || selectedTypeTabName == 'Employee Goals' ||
    selectedTypeTabName == 'Team Goals' || selectedTypeTabName == 'Dept KPIs' || selectedTypeTabName == 'Dotted Goals'">
        <ion-row>
            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="p-0">
                <ion-row class="p-0">
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                        <ion-label class="formLabelRegularfs14">Year</ion-label>
                    </ion-col>
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                        <ion-label class="formLabelRegularfs14">From</ion-label>
                    </ion-col>
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                        <ion-label class="formLabelRegularfs14">To</ion-label>
                    </ion-col>
                </ion-row>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="p-0">
                <ion-row class="p-0">
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                        <ng-select [clearable]="false" placeholder="Select" [(ngModel)]="selectedYear"
                            (change)="chnageSelectYear()">
                            <ng-option [value]="item.year"
                                *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                        </ng-select>
                    </ion-col>
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                        <ng-select [clearable]="false" placeholder="Select" [(ngModel)]="fromDate"
                            (change)="formMonthChange();getKPIsByDateRange()">
                            <ng-option [value]="item"
                                *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                        </ng-select>
                    </ion-col>
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                        <ng-select [clearable]="false" placeholder="Select" [(ngModel)]="toDate"
                            (change)="getListOfEmployee();getKPIsByDateRange()">
                            <ng-option [value]="item"
                                *ngFor="let item of getToMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                        </ng-select>
                    </ion-col>
                </ion-row>
            </ion-col>
            <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="text-right">
                <div class="d-flex float-right">
                    <button *ngIf="selectedTypeTabName == 'My Goals' || selectedTypeTabName == 'Team Goals' ||
                        selectedTypeTabName == 'Employee Goals'" (click)="showKPISPopup('Previous Months KPI')"
                        type="button" class="pms_btn center-content fs-14 ml-5"><span class="displayContent">
                            <span class="material-icons fs-20 mr-5">calendar_today</span>
                            Previous Months KPI</span></button>
                    <button *ngIf="!loggedInUserIsMD && selectedTypeTabName != 'Dotted Goals'" (click)="showKPISPopup('Reporting Manager KPI')" type="button"
                        class="pms_btn center-content fs-14 ml-5"><span class="displayContent">
                            <span class="material-icons fs-20 mr-5">person</span>
                            Reporting Manager KPI</span></button>
                    <button *ngIf="!loggedInUserIsMD" (click)="showKPISPopup('Company KPI')" type="button"
                        class="pms_btn center-content fs-14 ml-5"><span class="displayContent">
                            <span class="material-icons fs-20 mr-5">apartment</span>
                            Company KPI</span></button>
                    <button (click)="showKPISPopup('Repository')" type="button"
                        class="pms_btn center-content fs-14 ml-5"><span class="displayContent">
                            <span class="material-icons fs-20 fs-16 mr-5">lan</span>
                            Repository</span></button>
                </div>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="d-flex">
                    <!-- <ng-select [clearable]="false" placeholder="Select Dept" class="w-30 mr-5"
                        [(ngModel)]="selectedDeptForKPISearch" (change)="getAllEmployeesByDept()"
                        *ngIf="selectedTypeTabName == 'Employee Goals'">
                        <ng-option [value]="item.id" *ngFor="let item of deptListOfCompany">{{item.name}}</ng-option>
                    </ng-select> -->
                    <ng-multiselect-dropdown *ngIf="selectedTypeTabName == 'Employee Goals'" class="w250 mr-5 d-flex"
                        [placeholder]="'Select Dept'" [settings]="dropdownSettings" [data]="deptListOfCompany"
                        [(ngModel)]="selectedDeptForKPISearch" (onSelect)="getAllEmployeesByDept()"
                        (onDeSelect)="getAllEmployeesByDept()" (onSelectAll)="selectAllDept($event)"
                        (onDeSelectAll)="onDeSelectAllDept()"></ng-multiselect-dropdown>

                    <!-- <ng-select placeholder="Select Employee" class="w-30" [(ngModel)]="selectedUserForKPISearch"
                        (change)="getKPIsByDateRange()" *ngIf="selectedTypeTabName == 'Employee Goals'">
                        <ng-option [value]="item.id" *ngFor="let item of teamOfManagerList">{{item.name}}</ng-option>
                    </ng-select> -->
                    <ng-select [clearable]="false" placeholder="Select Employee" class="w250"
                        [(ngModel)]="selectedUserForKPISearch"
                        (change)="getPmsUnlockSetupForUser();targetApprovedMonths();getKPIsByDateRange();"
                        *ngIf="selectedTypeTabName == 'Team Goals' ||
                        selectedTypeTabName == 'Dept KPIs' || selectedTypeTabName == 'Employee Goals' || selectedTypeTabName == 'Dotted Goals'">
                        <ng-option [value]="item.id" *ngFor="let item of teamOfManagerList">{{item.name}}</ng-option>
                    </ng-select>
                    <button *ngIf="selectedTypeTabName == 'Employee Goals'"
                        (click)="onClickRecalculate('recalculate all')"
                        title="Recalculate the 'Pending' status score for the selected month for all employees"
                        type="button" class="pms_btn center-content fs-14 ml-5"><span class="displayContent">
                            <img src="././assets/icon/RecalculateIcon.svg">
                            Recalculate All</span></button>

                </div>
            </ion-col>
        </ion-row>
        <div class="tableCardBox mb-15"
            *ngIf="(selectedTypeTabName == 'My Goals' 
        || (selectedTypeTabName == 'Employee Goals' && selectedUserForKPISearch!=null)
        || (selectedTypeTabName == 'Team Goals' && selectedUserForKPISearch!=null)
        || (selectedTypeTabName == 'Dept KPIs' && selectedUserForKPISearch!=null)
        || (selectedTypeTabName == 'Dotted Goals' && selectedUserForKPISearch!=null)) && fromDate!=null && toDate!=null">
            <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="d-flex">
                        <button *ngIf="selectedKPIList.length>0" (click)="softDeleteGoalSetting()"
                            class="materialBtnIcon red fs-14 font_semibold mr-15">
                            <span class="material-icons fs-20">delete</span></button>
                        <mat-form-field class="mat-height40 mat-input-style">
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput type="search" placeholder="Search" [(ngModel)]="searchKpiString"
                                (input)="onKpiSearch(searchKpiString)">
                        </mat-form-field>
                        <!-- <ion-label class="center-content ml-10 fs-14 font_medium pr-10 black_color">Show</ion-label>
                        <mat-form-field class="w70px mat-height40 mat-input-style">
                            <mat-select placeholder="Select" placeholder="Select" [(ngModel)]="selectedSizeOfPMS"
                                (selectionChange)="onSelectSizeOfKpis()">
                                <mat-option [value]="25">25</mat-option>
                                <mat-option [value]="50">50</mat-option>
                                <mat-option [value]="75">75</mat-option>
                                <mat-option [value]="100">100</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <ion-label class="center-content fs-14 font_medium pl-10 black_color">entries</ion-label> -->
                    </div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                    <div class="d-flex float-right">
                        <div class="center-content mr-10 pr-10 borderRight"
                            title="Recalculate the 'Pending' status score for the selected month - Individual Employee"
                            *ngIf="selectedTypeTabName == 'Employee Goals' && isKPIInPendingState">
                            <span class="font_regular link fs-12 cp" (click)="onClickRecalculate('recalculate')"><img
                                    src="././assets/icon/RecalculateIcon.svg"></span>
                        </div>
                        <div class="mr-15" *ngIf="isAnyColumnInvisible">
                            <div class="font_regular fs-12">Some Columns are hidden-</div>
                            <div class="font_regular fs-12 text-right" [style.color]="buttonColorName"><u class="cp"
                                    (click)="onClickShowAllHeader()">click here to show all</u></div>
                        </div>
                        <button *ngIf="goalSettingAtAllLevels &&
                        (selectedTypeTabName == 'Employee Goals' || (selectedTypeTabName == 'Team Goals') ||
                        (selectedTypeTabName == 'My Goals'))" type="button" class="add_btn fs-14 mr-15"
                            [style.background-color]="buttonColorName" (click)="addKPISPopup()">
                            + New KPI</button>
                        <button (click)="downloadUserKpis()"
                            class="materialBtnIcon black_color fs-14 font_semibold mr-15">
                            <span class="material-icons">download</span></button>
                        <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                            class="customMaterialIcon fs-14">
                            <span class="material-icons">tune</span></button>
                        <mat-menu #menu="matMenu" (closed)="onMenuClose()">
                            <ion-row>
                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                    *ngFor="let item of columnHeaderHideShowAllData" class="mat-checkbox-style">
                                    <mat-checkbox [(ngModel)]="item.isVisible"
                                        (change)="onSelectHideShowCheckBox($event)" [checked]="item.isVisible"
                                        value="true" (click)="$event.stopPropagation()"
                                        value=true>{{item.fieldName}}</mat-checkbox>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                                    <!-- <button type="button" class="add_btn fs-14 mr-10"
                                        [style.background-color]="buttonColorName"
                                        (click)="onClickHideShowColumnHeader(menu)">
                                        Apply</button> -->
                                </ion-col>
                            </ion-row>
                        </mat-menu>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row class="p-0 mt-5">
                <div class="table-container">
                    <table id="kpiTable" class="hover mb-5">
                        <thead class="bg-gray">
                            <tr>
                                <th class="w1 mat-checkbox-style"
                                    *ngIf="(isCuttofDateApplicable && ((selectedTypeTabName == 'Team Goals' && !goalApprovalStatus)
                                || (selectedTypeTabName == 'My Goals' && !goalApprovalStatus)) && !allColumnsInvisible) || (selectedTypeTabName == 'Employee Goals' && !allColumnsInvisible)">
                                    <mat-checkbox
                                        *ngIf="!goalApprovalStatus || (selectedTypeTabName == 'Employee Goals' && !allColumnsInvisible)"
                                        [(ngModel)]="selectAllCheckbox" [checked]="selectAllCheckbox==true" value=true
                                        (change)="selectALLRecords($event)"></mat-checkbox>
                                </th>
                                <ng-container *ngFor="let item of columnHeaderHideShowAllData;let i = index">
                                    <th [ngClass]="{'theadWidhtForGoal':item.fieldName=='KRA'|| item.fieldName=='KPI'}" class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            {{item.fieldName}}
                                            <span class="material-icons cp ml-5 mt-3 fs-14"
                                                (click)="updateColumnVisibility(item,i)">visibility_off</span>
                                        </div>
                                    </th>
                                </ng-container>
                                <!-- <th class="fs-14 font_bold cl-black" >
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Dotted Manger Comment
                                        <span class="material-icons cp ml-5 mt-3 fs-14"
                                           >visibility_off</span>
                                    </div>
                                </th> -->
                            </tr>
                        </thead>
                        <tbody class="bg-white">
                            <ng-container *ngFor="let item of kpiDataListByUserForTable;let k=index">
                                <tr *ngFor="let data of item.datalist;let i = index"
                                    [ngClass]="{'highlightBgRow': data.milestoneFrom!=null}">
                                    <td class="mat-checkbox-style"
                                        *ngIf="(isCuttofDateApplicable && ((selectedTypeTabName == 'Team Goals' && !goalApprovalStatus)
                                        || (selectedTypeTabName == 'My Goals' && !goalApprovalStatus)) && !allColumnsInvisible) || (selectedTypeTabName == 'Employee Goals' && !allColumnsInvisible)">
                                        <mat-checkbox
                                            *ngIf="!data.goalApprovalStatus || (selectedTypeTabName == 'Employee Goals' && !allColumnsInvisible)"
                                            [(ngModel)]="data.checkboxCheck"
                                            (change)="selectSingleRecord($event,data,k,i)"></mat-checkbox>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[0].isVisible">
                                        <span class="fs-14 font_regular"
                                            *ngIf="(selectedTypeTabName == 'Dept KPIs' ||
                                                selectedTypeTabName == 'Dotted Goals' || selectedTypeTabName == 'My Goals') || 
                                                (selectedTypeTabName == 'Team Goals' || selectedTypeTabName == 'Employee Goals' ) && !data.goalReviewStatus"
                                            [ngClass]="{'apprvoveBtn' : data.reviewStatus == 'Approved','rejectBtn': 
                                                data.reviewStatus == 'Rejected'}">{{data.reviewStatus}}
                                        </span>
                                        <span
                                            *ngIf="(selectedTypeTabName == 'Team Goals' || selectedTypeTabName == 'Employee Goals' ) && data.goalReviewStatus">
                                            <span class="fs-14 font_semibold"
                                                *ngIf="data.reviewStatus == 'Approved' || data.reviewStatus == 'Rejected'"
                                                [ngClass]="{'apprvoveBtn' : data.reviewStatus == 'Approved','rejectBtn': 
                                                data.reviewStatus == 'Rejected'}">{{data.reviewStatus}}
                                            </span>
                                            <img title="Approve" [ngClass]="{'notAllowedBtn' : !data.isEditable}"
                                                *ngIf="data.reviewStatus == 'Pending'"
                                                (click)="approveRejectReview(data,true)"
                                                src="././assets/icon/Approve.svg" class="cp mr-10">
                                            <img title="Reject" [ngClass]="{'notAllowedBtn' : !data.isEditable}"
                                                *ngIf="data.reviewStatus == 'Pending'"
                                                (click)="approveRejectReview(data,false)"
                                                src="././assets/icon/Reject.svg" class="cp">
                                            <img title="Revoke" *ngIf="(data.reviewStatus == 'Approved' || 
                                            data.reviewStatus == 'Rejected') && data.isRevoke"
                                                (click)="revokeGoalStatus(data)" src="././assets/icon/Revoke.svg"
                                                class="cp ml-10">
                                        </span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[1].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.kra}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[2].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.kpi}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[3].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.month}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[4].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.lesserIsBetter}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[5].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.milestoneFrom}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[6].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.milestoneTo}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[7].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.weightage}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[8].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.uom}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[9].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.target}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[10].isVisible">
                                        <span (click)="onClickEditKPIS(data)"
                                            *ngIf="data.actual==null && data.goalApprovalStatus && data.isEditable"
                                            class="fs-10 font_regular editBlue"><u>Click here</u></span>
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.actual}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[11].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.percentageAchievement}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[12].isVisible">
                                        <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.kpiScore}}</span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[13].isVisible">
                                        <span (click)="onClickEditKPIS(data)" *ngIf="data.employeeComment==null && data.goalApprovalStatus 
                                        && selectedTypeTabName == 'My Goals' && data.isEditable"
                                            class="fs-10 font_regular editBlue"><u>Click here</u></span>
                                        <textarea *ngIf="data.employeeComment!=null && data.goalApprovalStatus 
                                            && selectedTypeTabName != 'My Goals'" rows="2" cols="4"
                                            class="edittextarea" readonly [(ngModel)]="data.employeeComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <textarea *ngIf="data.employeeComment!=null && data.goalApprovalStatus 
                                            && selectedTypeTabName == 'My Goals' && !data.isEditable" rows="2" cols="4"
                                            class="edittextarea" readonly [(ngModel)]="data.employeeComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <textarea (click)="onClickEditKPIS(data)" *ngIf="data.employeeComment!=null && data.goalApprovalStatus 
                                            && selectedTypeTabName == 'My Goals' && data.isEditable" rows="2" cols="4"
                                            class="edittextarea" [(ngModel)]="data.employeeComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <!-- <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.employeeComment}}</span> -->
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[14].isVisible">
                                        <span (click)="onClickEditKPIS(data)" *ngIf="data.managerComment==null && data.goalApprovalStatus 
                                        && selectedTypeTabName == 'Team Goals' && data.isEditable"
                                            class="fs-10 font_regular editBlue"><u>Click here</u></span>
                                        <textarea *ngIf="data.managerComment!=null && data.goalApprovalStatus 
                                        && selectedTypeTabName != 'Team Goals'" rows="2" cols="4"
                                            class="edittextarea" readonly [(ngModel)]="data.managerComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <textarea *ngIf="data.managerComment!=null && data.goalApprovalStatus 
                                            && selectedTypeTabName == 'Team Goals' && !data.isEditable" rows="2" cols="4"
                                            class="edittextarea" readonly [(ngModel)]="data.managerComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <textarea (click)="onClickEditKPIS(data)" *ngIf="data.managerComment!=null && data.goalApprovalStatus 
                                            && selectedTypeTabName == 'Team Goals' && data.isEditable" rows="2" cols="4"
                                            class="edittextarea" [(ngModel)]="data.managerComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <!-- <span (click)="onClickEditKPIS(data)" class="fs-14 font_regular"
                                            [ngClass]="{'editBlue' : data.isEditable}">{{data.managerComment}}</span> -->
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[15].isVisible">
                                        <span (click)="onClickEditKPIS(data)" *ngIf="data.misAttachment==null && data.goalApprovalStatus 
                                        && (selectedTypeTabName == 'Employee Goals' || selectedTypeTabName == 'My Goals' ||
                                        selectedTypeTabName == 'Team Goals' ) && data.isEditable"
                                            class="fs-10 font_regular editBlue"><u>Click here</u></span>
                                        <span>
                                            <span class="link cp" *ngIf="data.misAttachment!=null" matTooltip="{{data.misAttachmentFileName}}" 
                                        (click)="downloadFiles(data.misAttachment,data.misFileName)">{{getFormattedString(data.misFileName)}}
                                        <span (click)="downloadFiles(data.misAttachment,data.misFileName)"
                                        class="ml-10 cp material-icons">download</span></span>

                                            <!-- <a class="cp link-wrapper" *ngIf="data.misAttachment!=null"
                                                [href]="data.misAttachment" matTooltip="{{data.misFileName}}" target="_blank">{{getFormattedString(data.misFileName)}}<div
                                                    class="ml-10 cp material-icons">download</div></a> -->
                                        </span>
                                    </td>
                                    <td *ngIf="columnHeaderHideShowAllData[16].isVisible && data==item.datalist[0]"
                                        [attr.rowspan]="item.datalist.length">
                                        <textarea *ngIf="selectedTypeTabName != 'Dotted Goals'" rows="2" cols="4"
                                            class="edittextarea" readonly [(ngModel)]="data.dottedManagerComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <textarea (ngModelChange)="checkLengthOfField(item.actionable)"
                                            *ngIf="selectedTypeTabName == 'Dotted Goals'" rows="2" cols="4"
                                            class="edittextarea" maxlength="255" (blur)="addDottedManagerComment(data)"
                                            placeholder="Type here.." [(ngModel)]="data.dottedManagerComment"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                    </td>
                                </tr>
                            </ng-container>
                            <!-- <tr *ngFor="let item of kpiDataListByUser;let k=index"> -->

                            <!-- <td *ngFor="let inneritem of columnHeaderHideShowAllData"
                                    [hidden]="!inneritem.isVisible">
                                    <span class="fs-14 font_regular text-blue cp" *ngIf="inneritem.isEditable && (selectedTypeTabName == 'Team Goals' 
                                        || selectedTypeTabName == 'My Goals' ||
                                        selectedTypeTabName == 'Employee Goals') && item.isEditable == true">
                                        <span (click)="onClickEditKPIS(item)"
                                            *ngIf="inneritem.fieldName != 'MIS Attachment'">{{item[getFieldKey(inneritem.fieldName)]}}</span>
                                        <span *ngIf="inneritem.fieldName == 'MIS Attachment'"><span
                                                class="cp link-wrapper"
                                                *ngIf="item[getFieldKey(inneritem.fieldName)]!=null"
                                                (click)="downloadMisFile(item[getFieldKey(inneritem.fieldName)],item[getFieldKey('MIS FileName')])">{{item[getFieldKey('MIS
                                                FileName')]}}<div class="ml-10 cp material-icons">download</div>
                                            </span></span>
                                    </span>
                                    <span class="fs-14 font_regular" *ngIf="inneritem.isEditable && (selectedTypeTabName == 'Team Goals' 
                                    || selectedTypeTabName == 'My Goals' ||
                                    selectedTypeTabName == 'Employee Goals') && item.isEditable == false">
                                        <span
                                            *ngIf="inneritem.fieldName != 'MIS Attachment'">{{item[getFieldKey(inneritem.fieldName)]}}</span>
                                        <span *ngIf="inneritem.fieldName == 'MIS Attachment'"><a class="cp link-wrapper"
                                                *ngIf="item[getFieldKey(inneritem.fieldName)]!=null"
                                                [href]="item[getFieldKey(inneritem.fieldName)]"
                                                target="_blank">{{item[getFieldKey('MIS FileName')]}}<div
                                                    class="ml-10 cp material-icons">download</div></a></span>
                                    </span>

                                    <span class="fs-14 font_regular" *ngIf="!inneritem.isEditable && (selectedTypeTabName == 'Team Goals' 
                                    || selectedTypeTabName == 'My Goals' || selectedTypeTabName == 'Employee Goals')">
                                        <span [hidden]="item[getFieldKey(inneritem.fieldName)] == 'Pending'">
                                            <span *ngIf="inneritem.fieldName != 'MIS Attachment'"
                                                [ngClass]="{'apprvoveBtn' : inneritem.fieldName == 'Review Status' && item[getFieldKey(inneritem.fieldName)] == 'Approved','rejectBtn': 
                                                inneritem.fieldName == 'Review Status' && item[getFieldKey(inneritem.fieldName)] == 'Rejected'}">{{item[getFieldKey(inneritem.fieldName)]}}</span>
                                            <span *ngIf="inneritem.fieldName == 'MIS Attachment'"><a
                                                    class="cp link-wrapper"
                                                    *ngIf="item[getFieldKey(inneritem.fieldName)]!=null"
                                                    [href]="item[getFieldKey(inneritem.fieldName)]"
                                                    target="_blank">{{item[getFieldKey('MIS FileName')]}}<div
                                                        class="ml-10 cp material-icons">download</div></a></span></span>
                                    </span>
                                    <span class="fs-14 font_regular" *ngIf="!inneritem.isEditable && (selectedTypeTabName == 'Team Goals' 
                                    || selectedTypeTabName == 'My Goals' || selectedTypeTabName == 'Employee Goals')">
                                        <span *ngIf="(!item.goalReviewStatus &&
                                        item[getFieldKey(inneritem.fieldName)] == 'Pending')">
                                            <span
                                                *ngIf="inneritem.fieldName != 'MIS Attachment'">{{item[getFieldKey(inneritem.fieldName)]}}</span>
                                            <span *ngIf="inneritem.fieldName == 'MIS Attachment'"><a
                                                    class="cp link-wrapper"
                                                    *ngIf="item[getFieldKey(inneritem.fieldName)]!=null"
                                                    [href]="item[getFieldKey(inneritem.fieldName)]"
                                                    target="_blank">{{item[getFieldKey('MIS FileName')]}}<div
                                                        class="ml-10 cp material-icons">download</div></a></span></span>
                                        <span *ngIf="selectedTypeTabName == 'My Goals' && item.goalReviewStatus && 
                                            item[getFieldKey(inneritem.fieldName)] == 'Pending'">
                                            <span
                                                *ngIf="inneritem.fieldName != 'MIS Attachment'">{{item[getFieldKey(inneritem.fieldName)]}}</span>
                                            <span *ngIf="inneritem.fieldName == 'MIS Attachment'"><a
                                                    class="cp link-wrapper"
                                                    *ngIf="item[getFieldKey(inneritem.fieldName)]!=null"
                                                    [href]="item[getFieldKey(inneritem.fieldName)]"
                                                    target="_blank">{{item[getFieldKey('MIS FileName')]}}<div
                                                        class="ml-10 cp material-icons">download</div></a></span>
                                        </span>
                                        <span
                                            *ngIf="(selectedTypeTabName == 'Team Goals' || selectedTypeTabName == 'Employee Goals' ) && item.goalReviewStatus">
                                            <img title="Approve" [ngClass]="{'notAllowedBtn' : !item.isEditable}"
                                                *ngIf="item[getFieldKey(inneritem.fieldName)] == 'Pending'"
                                                (click)="approveRejectReview(item,true)"
                                                src="././assets/icon/Approve.svg" class="cp mr-10">
                                            <img title="Reject" [ngClass]="{'notAllowedBtn' : !item.isEditable}"
                                                *ngIf="item[getFieldKey(inneritem.fieldName)] == 'Pending'"
                                                (click)="approveRejectReview(item,false)"
                                                src="././assets/icon/Reject.svg" class="cp">
                                            <img title="Revoke" *ngIf="(item[getFieldKey(inneritem.fieldName)] == 'Approved' || 
                                            item[getFieldKey(inneritem.fieldName)] == 'Rejected') && item.isRevoke"
                                                (click)="revokeGoalStatus(item)" src="././assets/icon/Revoke.svg"
                                                class="cp ml-10">
                                        </span>
                                    </span>
                                    <span class="fs-14 font_regular" *ngIf="selectedTypeTabName == 'Dept KPIs' ||
                                    selectedTypeTabName == 'Dotted Goals'">
                                        <span
                                            *ngIf="inneritem.fieldName != 'MIS Attachment'">{{item[getFieldKey(inneritem.fieldName)]}}</span>
                                        <span *ngIf="inneritem.fieldName == 'MIS Attachment'"><a class="cp link-wrapper"
                                                *ngIf="item[getFieldKey(inneritem.fieldName)]!=null"
                                                [href]="item[getFieldKey(inneritem.fieldName)]"
                                                target="_blank">{{item[getFieldKey('MIS FileName')]}}<div
                                                    class="ml-10 cp material-icons">download</div></a></span>
                                    </span>
                                </td> -->
                            <!-- </tr> -->
                            <tr *ngIf="kpiDataListByUser.length>0" style="border: none;">
                                <td style="border: none;"
                                    *ngIf="(isCuttofDateApplicable && ((selectedTypeTabName == 'Team Goals' && !goalApprovalStatus)
                                    || (selectedTypeTabName == 'My Goals' && !goalApprovalStatus)) && !allColumnsInvisible) || (selectedTypeTabName == 'Employee Goals' && !allColumnsInvisible)">
                                </td>
                                <td style="border: none;" *ngFor="let inneritem of columnHeaderHideShowAllData"
                                    [hidden]="!inneritem.isVisible">
                                    <button *ngIf="goalReviewStatus && inneritem.fieldName == 'Review Status' && (selectedTypeTabName == 'Employee Goals' || selectedTypeTabName == 'Team Goals') 
                                    && goalApprovalStatus" (click)="onClickApproveAll()" type="button"
                                        class="pms_btn link center-content fs-14 ml-5"><span
                                            class="link displayContent">
                                            Approve All</span></button>
                                    <span class="fs-14 font_bold" *ngIf="inneritem.fieldName == 'Weightage'">
                                        Total: <span [style.color]="buttonColorName">{{totalWeightage}}</span>
                                    </span>
                                    <span class="fs-14 font_bold" *ngIf="inneritem.fieldName == 'KPI Score'">
                                        Total: <span [style.color]="buttonColorName">{{totalKpiScore}}</span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <ion-row class="mb-5" *ngIf="kpiDataListByUser.length != 0">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
                            <ion-label class="fs-14 font_bold black_color">{{totalKpis}} entries</ion-label>
                            <!-- <ion-label class="fs-14 font_bold black_color">Showing {{showingCount}} to
                                {{showingOfCount}} of {{totalKpis}} entries</ion-label> -->
                        </ion-col>
                    </ion-row>
                </div>
            </ion-row>
        </div>
        <ion-row
            *ngIf="(selectedTypeTabName == 'My Goals' 
        || (selectedTypeTabName == 'Employee Goals' && selectedUserForKPISearch!=null)
        || (selectedTypeTabName == 'Team Goals' && selectedUserForKPISearch!=null)
        || (selectedTypeTabName == 'Dept KPIs' && selectedUserForKPISearch!=null)
        || (selectedTypeTabName == 'Dotted Goals' && selectedUserForKPISearch!=null)) && fromDate!=null && toDate!=null">
            <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9" class="center-content">
                <label class="fs-14 font_semibold black_color" *ngIf="targetApprovedMonthsList.length!=0 && (selectedTypeTabName == 'My Goals'||
                selectedTypeTabName == 'Employee Goals' || selectedTypeTabName == 'Team Goals' || selectedTypeTabName == 'Dotted Goals')">
                    Already Target Approved Months:&nbsp;
                </label>
                <label class="fs-14 font_semibold black_color"
                    *ngFor="let item of targetApprovedMonthsList;let isLast = last">
                    {{item.name}}{{isLast ? '' : ', '}}
                </label>
            </ion-col>
            <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="text-right display-end">
                <!-- <ul class="dt_pagination">
                    <ion-row class="float-right pgintn">
                        <li class="active fs-16 font_regular">{{currentPageNumberOfKpis}}</li>
                        <span class="fs-14 font_regular p-10">of {{totalPagesOfKpi}}</span>
                        <li class="fs-24 cp" (click)="previousPageKpi()"
                            [ngClass]="{'disableBtn': currentPageNumberOfKpis==1}">&lt;</li>
                        <li class="fs-24 cp" (click)="nextPageKpi()"
                            [ngClass]="{'disableBtn': currentPageNumberOfKpis>= totalPagesOfKpi}">&gt;</li>
                    </ion-row>
                </ul> -->
            </ion-col>
        </ion-row>
        <ion-row class="mb-15">
            <ion-col class="" size-sm="6" size-md="6" size-lg="6" size-xs="6">
                <div class="fs-14 red font_semibold" *ngIf="goalApprovalStatus && isButtonDisabledOfSubmitReviewApproval &&
            selectedTypeTabName == 'My Goals' && kpiDataListByUser.length>0">Next Step: Please fill in your self review
                    and submit for approval.
                </div>
                <div *ngIf="kpiDataListByUser.length!=0 && cftApprovedMonths.length!=0 && pmsSetupInformationForm.value.cftValue" class="fs-14 font_semibold black_color">
                    <div *ngFor="let item of cftApprovedMonths;">
                        {{sharedService.transform(item.month)}}
                        month is verified by CFT Member {{item.cftMemberName}} on {{item.cftVerificationDate|date:'dd-MM-yyyy | hh:mm a'}}
                    </div>
                </div><br>
                <div *ngIf="kpiDataListByUser.length!=0 && loggedInUserRole == 'Admin' && pmsSetupInformationForm.value.cftValue">
                    <button (click)="onClickVerifyByCFT()" class="add_btn fs-14" [disabled]="allCFTMonthsVerified" 
                    [ngClass]="{'green_btn' : allCFTMonthsVerified}"
                    [style.background-color]="buttonColorName">Verified by CFT Member</button>
                </div>
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="text-right"
                *ngIf="selectedTypeTabName == 'Employee Goals' && kpiDataListByUser.length>0 && searchKpiString==null">
                <button *ngIf="goalReviewStatus" [ngClass]="{'disableBtn' : !isButtonDisabledOfSubmitReview}"
                    [disabled]="!isButtonDisabledOfSubmitReview" (click)="managerReviewGoals()" type="button"
                    class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName">Approve Actuals</button>
                <button [ngClass]="{'disableBtn' : goalApprovalStatus}" [disabled]="goalApprovalStatus"
                    (click)="onClickApprovaeGoals()" type="button" class="add_btn fs-14"
                    [style.background-color]="buttonColorName">Approve Targets</button>
                <div class="fs-12 red font_regular" *ngIf="(greaterThan100WtMonths.length!=0 || lessThan100WtMonths.length!=0)">
                    <span *ngIf="lessThan100WtMonths.length!=0">Weightage is less then 100 in <span *ngFor="let item of lessThan100WtMonths;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span></span>
                    <span *ngIf="greaterThan100WtMonths.length!=0">Weightage is More then 100 in  <span *ngFor="let item of lessThan100WtMonths;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span></span>
                </div>
                <!-- Button of Approved Targets always Disabled Button-->
                <!-- <button *ngIf="goalApprovalStatus" [ngClass]="{'disableBtn' : goalApprovalStatus}"
                    [disabled]="goalApprovalStatus" type="button" class="add_btn fs-14 mr-10"
                    [style.background-color]="buttonColorName">Targets Approved</button> -->
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="text-right"
                *ngIf="selectedTypeTabName == 'My Goals' && kpiDataListByUser.length>0 && searchKpiString==null">
                <!-- Button for Send Approving of tragets-->
                <button *ngIf="!goalApprovalStatus" [ngClass]="{'disableBtn' : !isButtonDisabledOfSubmitTargetApproval}"
                    [disabled]="!isButtonDisabledOfSubmitTargetApproval" (click)="sendGoalForApproval()" type="button"
                    class="add_btn fs-14 mr-5" [style.background-color]="buttonColorName">Submit Target for
                    Approval</button>
                <!-- Button for Send Approving the Actuals-->
                <button *ngIf="goalApprovalStatus" [ngClass]="{'disableBtn' : !isButtonDisabledOfSubmitReviewApproval}"
                    [disabled]="!isButtonDisabledOfSubmitReviewApproval" (click)="sendGoalForReview()" type="button"
                    class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName">Submit Actuals for
                    Approval</button>
                <!-- Button of Targets Approved always Disabled Button-->
                <button *ngIf="goalApprovalStatus" [ngClass]="{'disableBtn' : goalApprovalStatus}"
                    [disabled]="goalApprovalStatus" type="button" class="add_btn fs-14"
                    [style.background-color]="buttonColorName">Targets Approved</button>
                <div class="fs-12 red font_regular" *ngIf="(greaterThan100WtMonths.length!=0 || lessThan100WtMonths.length!=0)">
                    <span *ngIf="lessThan100WtMonths.length!=0">Weightage is less then 100 in <span *ngFor="let item of lessThan100WtMonths;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span></span>
                    <span *ngIf="greaterThan100WtMonths.length!=0">Weightage is More then 100 in  <span *ngFor="let item of lessThan100WtMonths;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span></span>
                </div>
            </ion-col>

            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-right"
                *ngIf="selectedTypeTabName == 'Team Goals' && kpiDataListByUser.length>0 && searchKpiString==null">

                <!-- Button of Approved Actual always Disabled Button-->

                <!-- <button *ngIf="!isAllReviewStatusNotApproved" [ngClass]="{'disableBtn' : goalApprovalStatus}"
                    [disabled]="goalApprovalStatus" type="button" class="add_btn fs-14 mr-10"
                    [style.background-color]="buttonColorName">Approved Actuals</button> -->

                <!-- Button of Approve Actual-->
                <button *ngIf="goalReviewStatus" [ngClass]="{'disableBtn' : !isButtonDisabledOfSubmitReview}"
                    [disabled]="!isButtonDisabledOfSubmitReview" (click)="managerReviewGoals()" type="button"
                    class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName">Approve Actuals</button>
                <!-- Button of Approve Targets -->
                <button *ngIf="!goalApprovalStatus" [ngClass]="{'disableBtn' : !isButtonDisabledGoalApprove}"
                    [disabled]="!isButtonDisabledGoalApprove" (click)="onClickApprovaeGoals()" type="button"
                    class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName">Approve Targets</button>
                <!-- Button of Approved Targets always Disabled Button-->
                <button *ngIf="goalApprovalStatus" [ngClass]="{'disableBtn' : goalApprovalStatus}"
                    [disabled]="goalApprovalStatus" type="button" class="add_btn fs-14 mr-10"
                    [style.background-color]="buttonColorName">Targets Approved</button>
                <div class="fs-12 red font_regular" *ngIf="(greaterThan100WtMonths.length!=0 || lessThan100WtMonths.length!=0)">
                    <span *ngIf="lessThan100WtMonths.length!=0">Weightage is less then 100 in <span *ngFor="let item of lessThan100WtMonths;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span></span>
                    <span *ngIf="greaterThan100WtMonths.length!=0">Weightage is More then 100 in  <span *ngFor="let item of lessThan100WtMonths;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span></span>
                </div>
            </ion-col>
        </ion-row>
        <div class="clear20"></div>
    </div>

    <!-- --------------------------------------Reports--------------------------------- -->

    <div class="container" *ngIf="selectedTypeTabName == 'Reports'">
        <ion-row class="pl-0 pt-5 pb-5 pr-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5">
                <div class="d-flex">
                    <button *ngFor="let item of reportBtn;let i = index"
                        [ngStyle]="item.isActive ? {'background-color': subModuleButtonColor, 'color': 'white'} : {}"
                        (click)="showScoreCardReport(item,i)" type="button"
                        class="pms_btn center-content fs-14 mr-5"><span class="displayContent">
                            {{item.btnName}}</span></button>
                </div>
            </ion-col>
        </ion-row>
        <ion-row class="pl-0 pt-5 pb-5 pr-5">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5">
                <div class="">
                    <ion-row class="p-0">
                        <ng-select [clearable]="false" placeholder="Select Year" [(ngModel)]="selectedYear"
                            (change)="chnageSelectYear()">
                            <ng-option [value]="item.year"
                                *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                        </ng-select>

                        <ng-multiselect-dropdown class="ml-5 w150" *ngIf="activeReportBtnName == 'Scorecard' || activeReportBtnName == 'KPI wise YTD' ||
                        activeReportBtnName == 'Review Compliance Report'" [placeholder]="'Select Month'"
                            [settings]="dropdownSettings" [data]="getMonthsByFiscalandReviewCycleForReport"
                            [(ngModel)]="selectedReviewCycle" (onSelect)="onSelectMonthReport()"
                            (onDeSelect)="onDeSelectMonthReport()" (onSelectAll)="selectAllReportMonth($event)"
                            (onDeSelectAll)="onDeSelectAllReportMonth()"></ng-multiselect-dropdown>

                        <!-- <ng-select [clearable]="false" *ngIf="activeReportBtnName == 'Scorecard' || activeReportBtnName == 'KPI wise YTD' ||
                        activeReportBtnName == 'Review Compliance Report'" [multiple]="true" class="w-15 ml-5"
                            placeholder="Select Month" [(ngModel)]="selectedReviewCycle">
                            <ng-option [value]="item"
                                *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                        </ng-select> -->

                        <div class="d-flex" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
                        || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' || loggedInUserRole == 'Admin'">
                            <!-- <ng-select class="ml-5" [closeOnSelect]="false" *ngIf="activeReportBtnName == 'Scorecard' || 
                        activeReportBtnName == 'All Employee -Month-YTD' || activeReportBtnName == 'KPI wise YTD' ||
                        activeReportBtnName == 'Review Compliance Report'" (change)="getEmpsByDept()" [multiple]="true"
                                placeholder="Select Department" [(ngModel)]="selectedDepartmentsForReport">
                                <ng-option [value]="item" *ngFor="let item of deptListOfCompany">{{item}}</ng-option>
                            </ng-select> -->
                            <!-- <ng-select class="ml-5" [closeOnSelect]="false" *ngIf="activeReportBtnName == 'Scorecard' || 
                          activeReportBtnName == 'All Employee -Month-YTD' || activeReportBtnName == 'KPI wise YTD' ||
                          activeReportBtnName == 'Review Compliance Report'" [multiple]="true"
                                placeholder="Select Employee" [(ngModel)]="selectedUserForKPIReport">
                                <ng-option [value]="item.id"
                                    *ngFor="let item of employeeListByDept">{{item.name}}</ng-option>
                            </ng-select> -->

                            <ng-multiselect-dropdown class="ml-5 w250" *ngIf="activeReportBtnName == 'Scorecard' || 
                            activeReportBtnName == 'All Employee -Month-YTD' || activeReportBtnName == 'KPI wise YTD' ||
                            activeReportBtnName == 'Review Compliance Report'" [placeholder]="'Select Department'"
                                [settings]="dropdownSettings" [data]="deptListOfCompany"
                                [(ngModel)]="selectedDepartmentsForReport" (onSelect)="getEmpsByDept()"
                                (onDeSelect)="getEmpsByDept()" (onSelectAll)="selectAllOnReportDept($event)"
                                (onDeSelectAll)="onDeSelectAllReportDept()"></ng-multiselect-dropdown>
                            <!-- <div class="d-flex" *ngIf="employeeListByDept.length> 0"> -->
                            <ng-multiselect-dropdown class="ml-5 w250" *ngIf="activeReportBtnName == 'Scorecard' || 
                          activeReportBtnName == 'All Employee -Month-YTD' || activeReportBtnName == 'KPI wise YTD' ||
                          activeReportBtnName == 'Review Compliance Report'" [placeholder]="'Select Employee'"
                                [settings]="dropdownSettings" [data]="employeeListByDept"
                                [(ngModel)]="selectedUserForKPIReport" (onSelectAll)="selectAllReportEmp($event)"
                                (onDeSelectAll)="onDeSelectAllReportEmp()"></ng-multiselect-dropdown>
                            <!-- </div> -->
                            <ng-select [clearable]="false" *ngIf="activeReportBtnName == 'Review Compliance Summary'"
                                class="ml-5" placeholder="Select Summary" (change)="changeSummaryReport()"
                                [(ngModel)]="selectedSummaryTypeForReport">
                                <ng-option value="Company Summary">Company Summary</ng-option>
                                <ng-option value="Dept wise Summary">Dept wise Summary</ng-option>
                            </ng-select>
                            <ng-multiselect-dropdown class="ml-5 w250"
                                *ngIf="activeReportBtnName == 'Review Compliance Summary' && selectedSummaryTypeForReport == 'Dept wise Summary'"
                                [placeholder]="'Select Employee'" [settings]="dropdownSettings"
                                [data]="deptListOfCompany" [(ngModel)]="selectedDepartmentForReport"
                                (onSelectAll)="selectAllDeptForReport($event)"
                                (onDeSelectAll)="onDeSelectAllDeptForReport()"></ng-multiselect-dropdown>
                        </div>


                        <div class="d-flex" *ngIf="loggedInUserRole == 'HOD'
                        || loggedInUserRole == 'Manager'">
                            <div *ngIf="activeReportBtnName == 'All Employee -Month-YTD' || activeReportBtnName == 'Review Compliance Report'"
                                class="center-content">
                                <label class="formLabelRegularfs14 mb-5 ml-10 mr-10">All Employee</label>
                                <mat-slide-toggle [checked]="isAllEmpForReportToggle" [(ngModel)]="isAllEmpForReportToggle"
                                    (change)="togglePanelForReportAllEmp()"></mat-slide-toggle>
                            </div>
                            <ng-select [clearable]="false"
                                *ngIf="(activeReportBtnName == 'Scorecard' && loggedInUserRole != 'Employee') ||
                        (activeReportBtnName == 'KPI wise YTD' && loggedInUserRole != 'Employee') || (!isAllEmpForReportToggle && activeReportBtnName == 'All Employee -Month-YTD' && loggedInUserRole != 'Employee')
                        || (!isAllEmpForReportToggle && activeReportBtnName == 'Review Compliance Report' && loggedInUserRole != 'Employee')"
                                class="w150 ml-5" placeholder="Select Goals" [(ngModel)]="selectedGoalForEmp"
                                (change)="getEmployeeListOnGoal()">
                                <ng-option value="My Goals">My Goals</ng-option>
                                <ng-option value="Team Goals">Team Goals</ng-option>
                                <ng-option value="Dept Goals">Dept Goals</ng-option>
                            </ng-select>
                            <div class="d-flex" *ngIf="teamOfManagerList.length> 0">
                                <ng-multiselect-dropdown class="ml-5 w250"
                                    *ngIf="(selectedGoalForEmp == 'Team Goals'&& !isAllEmpForReportToggle) || 
                                (selectedGoalForEmp == 'Dept Goals' && !isAllEmpForReportToggle)
                                || (activeReportBtnName == 'Scorecard' && (selectedGoalForEmp == 'Team Goals'||selectedGoalForEmp == 'Dept Goals'))
                                || (activeReportBtnName == 'KPI wise YTD' && (selectedGoalForEmp == 'Team Goals'||selectedGoalForEmp == 'Dept Goals'))"
                                    [placeholder]="'Select Employee'" [settings]="dropdownSettings"
                                    [data]="teamOfManagerList" [(ngModel)]="selectedUserForKPIReport"
                                    (onSelectAll)="selectAllReportEmp($event)"
                                    (onDeSelectAll)="onDeSelectAllReportEmp()"></ng-multiselect-dropdown>
                            </div>


                            <!-- <ng-select [clearable]="false"
                                *ngIf="(selectedGoalForEmp == 'Team Goals'&& !isAllEmpForReportToggle) || 
                            (selectedGoalForEmp == 'Dept Goals' && !isAllEmpForReportToggle)
                            || (activeReportBtnName == 'Scorecard' && (selectedGoalForEmp == 'Team Goals'||selectedGoalForEmp == 'Dept Goals'))"
                                placeholder="Select Employee" [multiple]="true" class="w-30 ml-5"
                                [(ngModel)]="selectedUserForKPIReport" [closeOnSelect]="false">
                                <ng-option [value]="item.id"
                                    *ngFor="let item of teamOfManagerList">{{item.name}}</ng-option>
                            </ng-select> -->
                        </div>
                        <button type="button" class="center-content add_btn fs-14 ml-5"
                            [style.background-color]="buttonColorName" (click)="submiForReportPreview()">
                            <img src="././assets/icon/submitIcon.svg" class="mr-5"> Submit</button>
                        <div class="center-content ml-15"><u class="cp link" (click)="onClickClearFilterReport()">Clear
                                Filter</u></div>
                    </ion-row>
                </div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5 text-right">
                <div class="d-flex float-right">
                    <button (click)="downloadExcelReport()" title="Download Excel" type="button"
                        class="imageIcon center-content fs-14"><span
                            class="ml-5 mr-5 fs-20 material-icons">download</span><span
                            class="mr-10">Excel</span></button>
                    <button *ngIf="activeReportBtnName != 'Custom Report'" (click)="downloadPdfReport()"
                        title="Download PDF" type="button" class="imageIcon center-content fs-14 ml-5"><span
                            class="ml-5 mr-5 fs-20 material-icons">download</span><span
                            class="mr-10">Pdf</span></button>

                </div>
            </ion-col>
        </ion-row>
        <div class="tableCardBox mb-15">
            <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                    <mat-form-field class="mat-height40 mat-input-style">
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="Search" [(ngModel)]="searchKpiReportString"
                            (input)="submiForReportPreview()">
                    </mat-form-field>
                </ion-col>
                <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8">
                    <div class="d-flex float-right">
                        <!-- <div class="mr-10">
                            <div class="font_regular fs-12">Some Columns are hidden-</div>
                            <div class="font_regular fs-12 text-right" [style.color]="buttonColorName"><u class="cp"
                                    (click)="onClickShowAllHeader()">click here to show all</u></div>
                        </div>
                        <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                            class="customMaterialIcon fs-14">
                            <span class="material-icons">tune</span></button> -->
                        <mat-menu #menu="matMenu" (closed)="onMenuClose()">
                            <ion-row>
                                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                                    *ngFor="let item of reportColumnHeaderInfoData" class="mat-checkbox-style">
                                    <mat-checkbox (change)="updateHideShowColReport(item.label,item.isVisible)"
                                        [(ngModel)]="item.isVisible" [checked]="item.isVisible" value="true"
                                        (click)="$event.stopPropagation()" value=true>{{item.label}}</mat-checkbox>
                                </ion-col>
                            </ion-row>
                            <!-- <ion-row>
                                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                                    <button type="button" class="add_btn fs-14 mr-10"
                                        [style.background-color]="buttonColorName"
                                        (click)="onClickHideShowColumnHeader(menu)">
                                        Apply</button>
                                </ion-col>
                            </ion-row> -->
                        </mat-menu>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row class="p-0 mt-5">
                <div class="table-container">
                    <div *ngIf="activeReportBtnName == 'Scorecard'">
                        <table id="reportTable" *ngFor="let item of employeesScoreCardReportData"
                            class="hover mb-15 borderbottomForReportTable">
                            <thead>
                                <tr>
                                    <th style="background-color: #FFFFFF;" colspan="7"></th>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <th class="monththead fs-14 font_bold" colspan="6">
                                            {{sharedService.transform(month)}}</th>
                                    </ng-container>
                                </tr>
                                <tr>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Emp ID
                                            <!-- <span (click)="updateHideShowColReport('Emp ID',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Emp Name
                                            <!-- <span (click)="updateHideShowColReport('Emp Name',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Manager
                                            <!-- <span (click)="updateHideShowColReport('Emp Name',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Department
                                            <!-- <span (click)="updateHideShowColReport('Emp Name',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            KRA
                                            <!-- <span (click)="updateHideShowColReport('KRA',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            KPI
                                            <!-- <span (click)="updateHideShowColReport('KPI',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Milestone Month
                                            <!-- <span (click)="updateHideShowColReport('KPI',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                WT
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Target
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Unit
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Actuals
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                %ge Achievement
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                KPI Score
                                                <!-- <span (click)="updateHideShowColReport('KPI Score',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let innerItemitem of item?.response">
                                    <td class="fs-14 font_regular">{{innerItemitem.employeeId }}</td>
                                    <td class="fs-14 font_regular">{{innerItemitem.firstName }}
                                        {{innerItemitem.lastName }}</td>
                                    <td class="fs-14 font_regular">{{ innerItemitem.manager }} </td>
                                    <td class="fs-14 font_regular">{{ innerItemitem.department }} </td>
                                    <td class="fs-14 font_regular">{{ innerItemitem.kra }} </td>
                                    <td class="fs-14 font_regular">{{ innerItemitem.kpi }}</td>
                                    <td class="fs-14 font_regular">{{ innerItemitem.milestoneMonths }}</td>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <td *ngIf="scorecardShowWTCol" class="fs-14 font_regular">{{
                                            getEmployeeMonthDataScorecard(innerItemitem,
                                            month).weighatge }}</td>
                                        <td *ngIf="scorecardShowKpiScoreCol" class="fs-14 font_regular">{{
                                            getEmployeeMonthDataScorecard(innerItemitem,
                                            month).target }}
                                        </td>
                                        <td *ngIf="scorecardShowKpiScoreCol" class="fs-14 font_regular">{{
                                            getEmployeeMonthDataScorecard(innerItemitem,
                                            month).unit }}
                                        </td>
                                        <td *ngIf="scorecardShowKpiScoreCol" class="fs-14 font_regular">{{
                                            getEmployeeMonthDataScorecard(innerItemitem,
                                            month).actual }}
                                        </td>
                                        <td *ngIf="scorecardShowKpiScoreCol" class="fs-14 font_regular">{{
                                            getEmployeeMonthDataScorecard(innerItemitem,
                                            month).percentageAchievement }}
                                        </td>
                                        <td *ngIf="scorecardShowKpiScoreCol" class="fs-14 font_regular">{{
                                            getEmployeeMonthDataScorecard(innerItemitem,
                                            month).kpiScore }}
                                        </td>
                                    </ng-container>
                                </tr>
                                <tr>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <td style="border: none;" class="nowrap fs-14 font_bold cl-black">
                                            Total: <span
                                                [style.color]="buttonColorName">{{calculateTotalWtForScorecard(item,month)}}</span>
                                        </td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;" class="nowrap fs-14 font_bold cl-black">
                                            Total: <span
                                                [style.color]="buttonColorName">{{calculateTotalKpiScoreForScorecard(item,month)}}</span>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                            <tr style="border: none;padding: 0px;">
                                <td style="border: none;padding: 0px;" >
                                    <div class="nowrap fs-14 font_bold cl-black">
                                        Total WT: <span
                                            [style.color]="buttonColorName">{{item.ytdWt}}</span>
                                    </div>
                                </td>
                                <td style="border: none;padding: 0px;" ></td>
                                <td style="border: none;padding: 0px;" >                                            
                                    <span class="fs-14 font_semibold">{{item?.response?.length}} entries</span>
                                </td>
                            </tr>
                            <tr style="border: none;padding: 0px;" >
                                <td style="border: none;padding: 0px;" >
                                    <div style="border: none;padding: 0px;" class="mb-5 nowrap fs-14 font_bold cl-black">
                                        Total YTD: <span
                                            [style.color]="buttonColorName">{{item.ytdScore}}</span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <table id="reportTable2" *ngIf="activeReportBtnName == 'All Employee -Month-YTD'" class="hover mb-15">
                        <thead>
                            <tr>
                                <th style="background-color: #FFFFFF;" colspan="8"></th>
                                <ng-container *ngFor="let month of monthsForScoreCardReport">
                                    <th class="monththead fs-14 font_bold" colspan="2">
                                        {{sharedService.transform(month)}}</th>
                                </ng-container>
                                <th class="monththead fs-14 font_bold" style="background-color: #FFFFFF;" colspan="4">
                                    Previous Years YTD Score
                                </th>
                            </tr>
                            <tr>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Emp ID
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Emp Name
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Email
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Department
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Manager
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Designation
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        DOJ
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Location
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <ng-container *ngFor="let month of monthsForScoreCardReport">
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Score
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            KPI approval
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                </ng-container>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        YTD
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        {{lastThreeYearRange[0]}}
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        {{lastThreeYearRange[1]}}
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        {{lastThreeYearRange[2]}}
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of employeesScoreCardReportData">
                                <td class="fs-14 font_regular">{{ item.employeeId }}</td>
                                <td class="fs-14 font_regular">{{ item.firstName }} {{ item.lastName }}</td>
                                <td class="fs-14 font_regular">{{ item.officialEmail}}</td>
                                <td class="fs-14 font_regular">{{ item.department }}</td>
                                <td class="fs-14 font_regular">{{ item.reportingmanagername }}</td>
                                <td class="fs-14 font_regular">{{ item.designation }}</td>
                                <td class="fs-14 font_regular">{{ item.dateOfJoining|date:'dd-MM-yyyy'}}</td>
                                <td class="fs-14 font_regular">{{ item.location }}</td>
                                <ng-container *ngFor="let month of monthsForScoreCardReport">
                                    <td class="fs-14 font_regular"
                                        [ngClass]="getEmployeeMonthDataAllMonthYtd(item,month).managerApprovalStatus == 'Approved' ? 'completeBgcolor' : 'incompletebgcolor'">
                                        {{ getEmployeeMonthDataAllMonthYtd(item,month).kpiScore }}</td>
                                    <td class="fs-14 font_regular"><span class="green">A:</span>&nbsp;{{
                                        getEmployeeMonthDataAllMonthYtd(item,
                                        month).approvedKpis }}&nbsp;|&nbsp;<span class="red">R:</span>&nbsp;{{
                                        getEmployeeMonthDataAllMonthYtd(item,
                                        month).rejectedKpis }}
                                    </td>
                                </ng-container>
                                <td class="fs-14 font_regular">{{ item.ytd }}</td>
                                <td class="fs-14 font_regular">{{ item.lastYearYtd }}</td>
                                <td class="fs-14 font_regular">{{ item.lastToLastYearYtd }}</td>
                                <td class="fs-14 font_regular">{{ item.yearBeforeLastToLastYearYtd }}</td>
                            </tr>
                        </tbody>
                        <div style="border: none;">
                            <span class="fs-14 font_semibold">{{employeesScoreCardReportData.length}} entries</span>
                        </div>
                    </table>
                    <div *ngIf="activeReportBtnName == 'KPI wise YTD'">
                        <table id="reportTable" *ngFor="let item of employeesScoreCardReportData"
                            class="hover mb-15 borderbottomForReportTable">
                            <thead>
                                <tr>
                                    <th style="background-color: #FFFFFF;" colspan="8"></th>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <th class="monththead fs-14 font_bold" colspan="6">
                                            {{sharedService.transform(month)}}</th>
                                    </ng-container>
                                    <th class="monththead fs-14 font_bold" colspan="3">KPI wise YTD</th>
                                </tr>
                                <tr>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Emp ID
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Emp Name
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Manager
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Department
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            KRA
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            KPI
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Milestone Month
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Lesser is better
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                WT
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Target
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Unit
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Actuals
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                %ge Achievement
                                                <!-- <span (click)="updateHideShowColReport('WT',false)" class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                KPI Score
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                    </ng-container>
                                    <ng-container>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                WT
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                %ge achievement
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                KPI Score
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let inneritem of item">
                                    <td class="fs-14 font_regular">{{ inneritem.employeeId }}</td>
                                    <td class="fs-14 font_regular">{{ inneritem.firstName }} {{ inneritem.lastName }}
                                    </td>
                                    <td class="fs-14 font_regular">{{ inneritem.reportingmanagername }}</td>
                                    <td class="fs-14 font_regular">{{ inneritem.department }}</td>
                                    <td class="fs-14 font_regular">{{ inneritem.kra }}</td>
                                    <td class="fs-14 font_regular">{{ inneritem.kpi }}</td>
                                    <td class="fs-14 font_regular">{{ inneritem.milestoneMonth }}</td>
                                    <td class="fs-14 font_regular">{{ inneritem.lesserIsBetter }}</td>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <td class="fs-14 font_regular">{{ getEmployeeMonthDataAllKpiwiseYtd(inneritem,
                                            month).weighatge }}</td>
                                        <td class="fs-14 font_regular">{{ getEmployeeMonthDataAllKpiwiseYtd(inneritem,
                                            month).target }}</td>
                                        <td class="fs-14 font_regular">{{ getEmployeeMonthDataAllKpiwiseYtd(inneritem,
                                            month).uom }}</td>
                                        <td class="fs-14 font_regular">{{ getEmployeeMonthDataAllKpiwiseYtd(inneritem,
                                            month).actual }}</td>
                                        <td class="fs-14 font_regular">{{ getEmployeeMonthDataAllKpiwiseYtd(inneritem,
                                            month).percentageAchievement }}</td>
                                        <td class="fs-14 font_regular">{{ getEmployeeMonthDataAllKpiwiseYtd(inneritem,
                                            month).kpiScore }}
                                        </td>
                                    </ng-container>
                                    <ng-container>
                                        <td class="fs-14 font_regular">
                                            {{inneritem.percentageResponse?.averageWeightage}}</td>
                                        <td class="fs-14 font_regular">
                                            {{inneritem.percentageResponse?.averagePercentageAchievement}}
                                        </td>
                                        <td class="fs-14 font_regular">{{inneritem.percentageResponse?.averagekpiScore}}
                                        </td>
                                    </ng-container>
                                </tr>
                                <tr>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <ng-container *ngFor="let month of monthsForScoreCardReport">
                                        <td style="border: none;" class="nowrap fs-14 font_bold cl-black">
                                            Total: <span
                                                [style.color]="buttonColorName">{{calculateTotalWtForKPIwiseytd(item,month)}}</span>
                                        </td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;"></td>
                                        <td style="border: none;" class="nowrap fs-14 font_bold cl-black">
                                            Total: <span
                                                [style.color]="buttonColorName">{{calculateTotalKpiScoreForKPIwiseytd(item,month)}}</span>
                                        </td>
                                    </ng-container>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                    <td style="border: none;"></td>
                                </tr>
                            </tbody>
                            <div style="border: none;">
                                <span class="fs-14 font_semibold">{{item.length}} entries</span>
                            </div>
                        </table>
                    </div>
                    <table id="reportTable2" *ngIf="activeReportBtnName == 'Review Compliance Report'" class="hover mb-15">
                        <thead>
                            <tr>
                                <th style="background-color: #FFFFFF;" colspan="8"></th>
                                <ng-container *ngFor="let month of monthsForScoreCardReport">
                                    <th class="monththead fs-14 font_bold" colspan="5">
                                        {{sharedService.transform(month)}}</th>
                                </ng-container>
                            </tr>
                            <tr>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Emp ID
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Emp Name
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Email
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Department
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Manager
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Designation
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        DOJ
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <th class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                        Location
                                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                    </div>
                                </th>
                                <ng-container *ngFor="let month of monthsForScoreCardReport">
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Score
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Goal setting status
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Goal review status
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            Approve/Reject by manager
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                    <th class="fs-14 font_bold cl-black">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            MIS status
                                            <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                        </div>
                                    </th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of employeesScoreCardReportData">
                                <td class="fs-14 font_regular">{{ item.employeeId }}</td>
                                <td class="fs-14 font_regular">{{ item.firstName }} {{ item.lastName }}</td>
                                <td class="fs-14 font_regular">{{ item.officialEmail }}</td>
                                <td class="fs-14 font_regular">{{ item.department }}</td>
                                <td class="fs-14 font_regular">{{ item.reportingManagerName }}</td>
                                <td class="fs-14 font_regular">{{ item.designation }}</td>
                                <td class="fs-14 font_regular">{{ item.dateOfJoining | date:'dd-MM-yyyy' }}</td>
                                <td class="fs-14 font_regular">{{ item.officeLocation }}</td>
                                <ng-container *ngFor="let month of monthsForScoreCardReport">
                                    <td class="fs-14 font_regular">{{ getReviewComplianceReportMonthData(item,
                                        month).kpiScore}}</td>
                                    <td class="fs-14 font_regular" [ngClass]="getReviewComplianceReportMonthData(item,
                                    month).goalSettingStatus=='Complete' ? 'completeBgcolor' : 'incompletebgcolor'">{{
                                        getReviewComplianceReportMonthData(item,
                                        month).goalSettingStatus}}</td>
                                    <td class="fs-14 font_regular" [ngClass]="getReviewComplianceReportMonthData(item,
                                            month).goalReviewStatus=='Complete' ? 'completeBgcolor' : 'incompletebgcolor'">{{
                                        getReviewComplianceReportMonthData(item,
                                        month).goalReviewStatus}}</td>
                                    <td class="fs-14 font_regular"
                                        [ngClass]="getReviewComplianceReportMonthData(item,
                                        month).managerApprovalStatus == 'Approved' ? 'completeBgcolor' : 'incompletebgcolor'">{{
                                        getReviewComplianceReportMonthData(item,
                                        month).managerApprovalStatus}}</td>

                                    <td class="fs-14 font_regular">{{ getReviewComplianceReportMonthData(item,
                                        month).totalMis? getReviewComplianceReportMonthData(item,
                                        month).totalMis : 0 }}/{{ getReviewComplianceReportMonthData(item,
                                        month).totalKpis ? getReviewComplianceReportMonthData(item,
                                        month).totalKpis : 0 }}</td>
                                </ng-container>
                            </tr>
                        </tbody>
                        <div style="border: none;">
                            <span class="fs-14 font_semibold">{{employeesScoreCardReportData.length}} entries</span>
                        </div>
                    </table>
                    <div *ngIf="activeReportBtnName == 'Review Compliance Summary'">
                        <div *ngFor="let item of employeesScoreCardReportData">
                            <div class="fs-14 font_bold mb-10">{{item.deptName}}</div>
                            <table id="reportTable2" class="hover mb-15">
                                <thead>
                                    <tr>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Month
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Active
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Exited
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                GS Completed
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                GR Completed
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                Approval By Manager
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>

                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                % GS Completed
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                % GR Completed
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                        <th class="fs-14 font_bold cl-black">
                                            <div class="verticle-center justify-content-space-between icon-style">
                                                % Approval By Manager
                                                <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let inneritem of item.summary">
                                        <td class="fs-14 font_regular">{{transFormMileStoneMonth(inneritem.month)}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.active}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.exited}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.gs}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.gr}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.managerApproval}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.percentageGsCompleted}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.percentageGrCompleted}}</td>
                                        <td class="fs-14 font_regular">{{inneritem.percentageManagerApproval}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="border: none;">
                                <span class="fs-14 font_semibold">{{item.summary.length}} entries</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="activeReportBtnName == 'Custom Report'">
                        <table id="customReport" *ngFor="let item of employeesScoreCardReportData"
                            class="hover mb-15 borderbottomForReportTable">
                            <thead>
                                <tr>
                                    <th class="fs-14 font_bold cl-black"
                                        *ngFor="let data of reportColumnHeaderInfoData">
                                        <div class="verticle-center justify-content-space-between icon-style">
                                            {{data.label}}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let inneritem of item">
                                    <td class="fs-14 font_regular">{{inneritem.employeeId}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.firstName}} {{inneritem.lastName}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.officialEmail}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.dateOfJoining | date:'dd-MM-yyyy'}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.dateOfExit | date:'dd-MM-yyyy'}}</td>
                                    <td class="fs-14 font_regular">{{sharedService.transform(inneritem.month)}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.reportingmanagercode}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.department}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.location}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.kra}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.kpi}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.reviewCycle}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.lesserIsBetter}}</td>
                                    <td class="fs-14 font_regular">{{sharedService.transform(toProperCase(inneritem.milestoneFrom))}}</td>
                                    <td class="fs-14 font_regular">{{sharedService.transform(toProperCase(inneritem.milestoneTo))}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.weightage}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.uom}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.target}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.actual}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.percentageAchievement}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.kpiScore}}</td>
                                    <td class="fs-14 font_regular">{{inneritem.reviewStatus}}</td>
                                    <td class="fs-14 font_regular">
                                        <textarea readonly class="textarea minw190"
                                        [(ngModel)]="inneritem.employeeComment"></textarea></td>
                                    <td class="fs-14 font_regular"><textarea readonly class="textarea minw190"
                                        [(ngModel)]="inneritem.managerComment"></textarea>
                                    </td>
                                    <td class="fs-14 font_regular"><textarea readonly class="textarea minw190"
                                        [(ngModel)]="inneritem.dottedManagerComment"></textarea>
                                    <td class="fs-14 font_regular">
                                        <span class="link cp" matTooltip="{{inneritem.misAttachmentFileName}}" 
                                        (click)="downloadFiles(inneritem.misAttachment,inneritem.misAttachmentFileName)">{{getFormattedString(inneritem.misAttachmentFileName)}}</span>
                                        <!-- <a class="link"
                                        matTooltip="{{inneritem.misAttachmentFileName}}" [href]="inneritem.misAttachment"></a> -->
                                    </td>
                                </tr>
                            </tbody>
                            <div style="border: none;">
                                <span class="fs-14 font_semibold">{{item.length}} entries</span>
                            </div>
                        </table>
                    </div>
                    <ion-row *ngIf="employeesScoreCardReportData.length==0">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text_center">
                            <label class="fs-14 font_semibold">No Data Found</label>
                        </ion-col>
                    </ion-row>
                </div>
            </ion-row>
            <ion-row *ngIf="activeReportBtnName == 'Scorecard' || activeReportBtnName == 'KPI wise YTD' || activeReportBtnName == 'Custom Report'">
            <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="center-content">
                <div class="fs-14 font_semibold">Showing {{(currentPageReport*4)-3}} to {{ (currentPageReport * 4) < totalCountOfReport ? (currentPageReport * 4) : totalCountOfReport }} of {{totalCountOfReport}} Employees</div>
            </ion-col>
            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="p-0 text-right display-end">
                <ul class="dt_pagination">
                <ion-row class="float-right pgintn">
                    <li class="active fs-16 font_regular">{{currentPageReport}}</li>
                    <span class="fs-14 font_regular p-10">of {{totalNoOfPagesReport}}</span>
                    <li class="fs-24 cp" (click)="previousPageReport()" [ngClass]="{'disableBtn': currentPageReport==1}">&lt;</li>
                    <li class="fs-24 cp" (click)="nextPageReport()" [ngClass]="{'disableBtn': currentPageReport>= totalNoOfPagesReport}">
                    &gt;</li>
                </ion-row>
                </ul>
            </ion-col>
            </ion-row>
        </div>
    </div>

    <div class="modal fade" [style.display]="showSetupPopup? 'block' : 'none'">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
                    <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBreadcrumPMS()">
                    <label class="font_semibold fs-18 ml-10 mt-5 black_color">
                        <span class="cp" (click)="onClickBreadcrumPMS()">PMS</span> / <span
                            [style.color]="buttonColorName">Setting</span></label>
                </div>
            </div>
            <div class="modal-body p-20">
                <div class="cardBox">
                    <form [formGroup]="pmsSetupInformationForm">
                        <ion-row>
                            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                                <div class="font_bold fs-16">PMS Settings</div>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <div class="formLabelSemiBoldfs16 mb-5">Fiscal Year<span class="red-cl">&nbsp;*</span>
                                </div>
                                <div class="w-80 inputBoxDisabled opacity5">
                                    {{sharedService.transform(pmsSetupInformationForm.value.fiscalYear)}}
                                </div>
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <div class="formLabelSemiBoldfs16 mb-5">Year<span class="red-cl">&nbsp;*</span>
                                </div>
                                <mat-form-field class="w-80 mat-height40 mat-input-style">
                                    <mat-select placeholder="Select" formControlName="year"
                                        (selectionChange)="onSelectYearForPMSSetup()">
                                        <mat-option [value]="item.year"
                                            *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="pmsSetupInformationForm.controls['year'].hasError('required')">Review
                                        Cycle is required</mat-error>
                                </mat-form-field>
                                <!-- <div class="inputBoxDisabled">{{pmsSetupInformationForm.value.year}}</div> -->
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <div class="formLabelSemiBoldfs16 mb-5">Review Cycle<span class="red-cl">&nbsp;*</span>
                                </div>
                                <mat-form-field class="w-80 mat-height40 mat-input-style">
                                    <mat-select [attr.readonly]="reviewCycleDisabled ? false: true"
                                        [disabled]="reviewCycleDisabled" placeholder="Select"
                                        formControlName="reviewCycle">
                                        <mat-option [value]="'Monthly'">Monthly</mat-option>
                                        <mat-option [value]="'Quarterly'">Quarterly</mat-option>
                                        <mat-option [value]="'Semi_Annually'">Semi-Annually</mat-option>
                                        <mat-option [value]="'Annually'">Annually</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="pmsSetupInformationForm.controls['reviewCycle'].hasError('required')">Review
                                        Cycle is required</mat-error>
                                </mat-form-field>
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <div class="formLabelSemiBoldfs16 mb-5">Goal Setting at all levels
                                </div>
                                <mat-slide-toggle class="mb-10"
                                    formControlName="goalSettingAtllLevels"></mat-slide-toggle>
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <label class="formLabelSemiBoldfs16 mb-5">Cutoff Date<span
                                        class="red-cl">&nbsp;*</span></label>
                                <mat-slide-toggle class="mb-10"
                                    formControlName="cutoffDateApplicable"></mat-slide-toggle>
                                <mat-form-field class="w-80 mat-height40 mat-input-style"
                                    *ngIf="pmsSetupInformationForm.value.cutoffDateApplicable == true">
                                    <mat-select (selectionChange)="chnageCutOffDate()" placeholder="Select"
                                        formControlName="cutoffDate">
                                        <mat-option *ngFor="let item of numbersOfDaysArray"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="pmsSetupInformationForm.controls['cutoffDate'].hasError('required')">Cutoff
                                        Date is required</mat-error>
                                </mat-form-field>
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10"
                                *ngIf="pmsSetupInformationForm.value.cutoffDateApplicable == true">
                                <div class="formLabelSemiBoldfs16 mb-9">Grace Period (day)<span
                                        class="red-cl">&nbsp;*</span>
                                </div>
                                <mat-form-field class="w-80 mat-height40 mat-input-style">
                                    <mat-select placeholder="Select" formControlName="gracePeriod">
                                        <mat-option *ngFor="let item of numbersOfDaysForGracePeriod"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="pmsSetupInformationForm.controls['gracePeriod'].hasError('required')">Grace
                                        Period is required</mat-error>
                                </mat-form-field>
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <label class="formLabelSemiBoldfs16 mb-5">CFT Member<span class="red-cl">&nbsp;*</span>
                                </label>
                                <mat-slide-toggle formControlName="cftValue"></mat-slide-toggle>
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10"
                                *ngIf="pmsSetupInformationForm.value.cutoffDateApplicable == true">
                            </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                                <label class="formLabelSemiBoldfs16 mb-5">Cap Value<span
                                        class="red-cl">&nbsp;*</span></label>
                                <mat-slide-toggle formControlName="capValue"></mat-slide-toggle>
                                <div *ngIf="pmsSetupInformationForm.value.capValue == true">
                                    <mat-radio-group aria-label="Select an option" formControlName="capSelect">
                                        <mat-radio-button [value]="'Straight'">Straight</mat-radio-button>
                                        <mat-radio-button [value]="'Range'">Range</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <mat-form-field class="w-80 mb-5 mat-height40 mat-input-style"
                                    *ngIf="pmsSetupInformationForm.value.capValue == true">
                                    <mat-select placeholder="Select Cap" formControlName="valueSelect"
                                        (selectionChange)="onSelectCapChnage()">
                                        <mat-option [value]="'Monthly_Cut_off'">Monthly Cap</mat-option>
                                        <mat-option [value]="'YTD_Cut_off'">YTD Cap</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="pmsSetupInformationForm.controls['valueSelect'].hasError('required')">Cut
                                        off is
                                        required</mat-error>
                                </mat-form-field>
                            </ion-col>
                            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-10 ion-col-bottom"
                                *ngIf="pmsSetupInformationForm.value.capSelect == 'Straight' && pmsSetupInformationForm.value.capValue == true">
                                <mat-form-field class="w-80 mat-height40 mat-input-style">
                                    <input matInput type="number" placeholder="Type number here" class="font_regular"
                                        formControlName="comment">
                                    <mat-error
                                        *ngIf="pmsSetupInformationForm.controls['comment'].hasError('required')">Cap
                                        is required</mat-error>
                                    <mat-error *ngIf="pmsSetupInformationForm.controls['comment'].hasError('minValue')">
                                        Cap should be more than or equal to 0
                                    </mat-error>
                                </mat-form-field>
                            </ion-col>
                        </ion-row>
                    </form>
                    <div [ngClass]="{'mt-15' : pmsSetupInformationForm.controls['valueSelect'].hasError('required')}"
                        *ngIf="pmsSetupInformationForm.value.capSelect == 'Range' && pmsSetupInformationForm.value.capValue == true">
                        <!-- <div formArrayName="addScores">
                                <ion-row
                                    *ngFor="let scoreRange of addScoresRange.controls; let i = index;let last = last"
                                    [formGroupName]="i">
                                    <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                                            <input matInput type="number" placeholder="Min Range" class="font_regular"
                                                formControlName="minRange">
                                        </mat-form-field>
                                    </ion-col>
                                    <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                                            <input matInput type="number" placeholder="Max Range" class="font_regular"
                                                formControlName="maxRange">
                                        </mat-form-field>
                                    </ion-col>
                                    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                                            <input matInput type="number" placeholder="Normalize Score"
                                                class="font_regular" formControlName="normalizeScore">
                                        </mat-form-field>
                                    </ion-col>

                                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                                        <ion-label class="fs-16 font_regular blue mt-20 cp mr-15" *ngIf="last"
                                            (click)="addMoreScoresRange()">+
                                            Add</ion-label>
                                        <ion-label class="fs-16 font_regular red mt-20 cp" *ngIf="i!=0"
                                            (click)="removecreateScoresRange(i)">Remove</ion-label>
                                    </ion-col>
                                </ion-row>
                            </div> -->

                        <ion-row *ngFor="let item of scoreRangeArrayForAdd">
                            <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                                <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                                            <input matInput type="number" placeholder="Min Range" class="font_regular"
                                            [(ngModel)]="item.minRange">
                                        </mat-form-field> -->
                                <div class="w-100 inputBox notAllowed"><span
                                        *ngIf="item.minRange!=0">></span>{{item.minRange}}</div>
                            </ion-col>
                            <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                                <mat-form-field class="w-100 mat-height40 mat-input-style">
                                    <input matInput type="number" placeholder="Max Range" class="font_regular"
                                        [(ngModel)]="item.maxRange" (blur)="onMaxRangeChange(item)">
                                </mat-form-field>
                                <label *ngIf="item.maxRange== null && errorMsgForRange"
                                    class="red-cl font_regular fs-12">Max Range is required</label>
                                <label *ngIf="isInValidMaxRange" class="red-cl font_regular fs-12">Max Range should be
                                    greater than Min Range</label>
                            </ion-col>
                            <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                                <mat-form-field class="w-100 mat-height40 mat-input-style">
                                    <input matInput type="number" placeholder="Normalize Score" class="font_regular"
                                        [(ngModel)]="item.normalizeScore" (blur)="checkNonZero(item)">
                                </mat-form-field>
                                <label *ngIf="item.normalizeScore== null && errorMsgForRange"
                                    class="red-cl font_regular fs-12">Normalize Score is required</label>
                                <label *ngIf="isInValidNormalizScore" class="red-cl font_regular fs-12">Normalize Score
                                    should be more than or equal to 0</label>
                            </ion-col>
                        </ion-row>

                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                            <ion-label *ngIf="scoreRangeArrayForAdd.length==0"
                                class="fs-16 font_regular blue mt-20 cp mr-15" (click)="addMoreScoreRange()">+
                                Add</ion-label>
                            <ion-label *ngIf="scoreRangeArrayForAdd.length!=0"
                                class="fs-16 font_regular blue mt-20 cp mr-15"
                                (click)="saveAddedScoreRange()">Save</ion-label>
                            <ion-label *ngIf="scoreRangeArrayForAdd.length!=0" class="fs-16 font_regular red mt-20 cp"
                                (click)="removecreateScoresRange()">Remove</ion-label>
                        </ion-col>

                        <ion-row>
                            <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7">
                                <ion-row class="p-0">
                                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                                        class="p-0 tableBorder brtopLeft8 tableBg text-center">
                                        <div class="formLabelSemiBoldfs14 p-10">Range for Score Normalization</div>
                                    </ion-col>
                                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                                        class="p-0 tableBorder tableBg text-center">
                                        <div class="formLabelSemiBoldfs14 p-10">Normalize Score</div>
                                    </ion-col>
                                    <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2"
                                        class="p-0 tableBorder brtopRight8 tableBg text-center">
                                        <div *ngIf="addedScores.length!=0" (click)="deleteAllRange()"
                                            class="fs-14 font_semibold">
                                            <!-- Delete All -->
                                            <span title="Delete All"
                                                class="material-icons red p-10 cp fs-20">delete</span>
                                        </div>
                                    </ion-col>
                                </ion-row>
                                <ion-row class="p-0" *ngFor="let data of addedScores;let i=index">
                                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                                        class="tableBorder text-center">
                                        <div *ngIf="editIndexofCapRange!=i" class="formLabelRegularfs14 p-10">
                                            <span *ngIf="data.minRange!=0">></span>{{data.minRange}} - {{data.maxRange}}
                                        </div>
                                        <!-- <mat-form-field *ngIf="editIndexofCapRange==i" class="w-30 mat-height40 mat-input-style">
                                                <input matInput type="number" placeholder="Min Range" class="font_regular"
                                                [(ngModel)]="data.minRange">
                                            </mat-form-field> -->
                                        <label *ngIf="editIndexofCapRange==i" class="inputBox notAllowed"><span
                                                *ngIf="data.minRange!=0">></span>{{data.minRange}}</label>
                                        <span *ngIf="editIndexofCapRange==i">&nbsp;-&nbsp;</span>
                                        <mat-form-field *ngIf="editIndexofCapRange==i"
                                            class="w-30 mat-height40 mat-input-style">
                                            <input matInput type="number" placeholder="Max Range" class="font_regular"
                                                [(ngModel)]="data.maxRange">
                                        </mat-form-field>
                                    </ion-col>
                                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                                        class="tableBorder text-center">
                                        <div *ngIf="editIndexofCapRange!=i" class="formLabelRegularfs14 p-10">
                                            {{data.normalizeScore}}</div>
                                        <mat-form-field *ngIf="editIndexofCapRange==i"
                                            class="w-100 mat-height40 mat-input-style">
                                            <input matInput type="number" placeholder="Normalize Score"
                                                class="font_regular" [(ngModel)]="data.normalizeScore">
                                        </mat-form-field>
                                    </ion-col>
                                    <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2"
                                        class="tableBorder text-center">
                                        <!-- <span *ngIf="editIndexofCapRange==i" class="material-icons link p-10 cp fs-20"
                                            (click)="editedRangeSave(i)">check</span>
                                        <span *ngIf="editIndexofCapRange==i" class="material-icons link p-10 cp fs-20"
                                            (click)="closeEditRange(i)">close</span>
                                        <span *ngIf="editIndexofCapRange!=i" class="material-icons link p-10 cp fs-20"
                                            (click)="editRange(i,data)">edit</span>
                                        <span *ngIf="editIndexofCapRange!=i" class="material-icons red p-10 cp fs-20"
                                            (click)="deleteRange(i)">delete</span> -->
                                    </ion-col>
                                </ion-row>
                                <label *ngIf="scoreRangeArrayForAdd.length==0 && addedScores.length==0"
                                    class="red-cl font_regular fs-12">Range for Score Normalization is required</label>
                            </ion-col>
                        </ion-row>
                    </div>
                </div>
                <div class="mt-10">
                    <button type="button" (click)="onClickBreadcrumPMS()" class="back_btn mr-10">Back</button>
                    <button *ngIf="!editPMSSetUp" [ngClass]="{'disableBtn' : !isSelectedYearIsSameYeartoCurrentYear}"
                        [disabled]="!isSelectedYearIsSameYeartoCurrentYear" (click)="onSavePMSSetup()" type="button"
                        class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName">
                        Save</button>
                    <button *ngIf="editPMSSetUp" [ngClass]="{'disableBtn' : !isSelectedYearIsSameYeartoCurrentYear}"
                        [disabled]="!isSelectedYearIsSameYeartoCurrentYear" (click)="updatePMSSetup()" type="button"
                        class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName">
                        Save</button>
                    <button type="button" [ngClass]="{'disableBtn' : !isSelectedYearIsSameYeartoCurrentYear}"
                        [disabled]="!isSelectedYearIsSameYeartoCurrentYear" (click)="onClickChroneJob()"
                        class="back_btn mr-10">Chrone Job</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" [style.display]="showSystemUnlockPopup? 'block' : 'none'">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
                    <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBreadcrumPMS()">
                    <label class="font_semibold fs-18 ml-10 mt-5 black_color">
                        <span class="cp" (click)="onClickBreadcrumPMS()">PMS</span> / <span
                            [style.color]="buttonColorName">System</span></label>
                </div>
            </div>
            <div class="modal-body pl-20 pt-10 pr-20 pb-20">
                <ion-row>
                    <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <ng-select class="w150" [clearable]="false" placeholder="Select"
                            [(ngModel)]="selectedYearForUnlockStatus" (change)="searchPmsUnlockStatusOfCompany()">
                            <ng-option [value]="item.year"
                                *ngFor="let item of pmsYearsForUnlockStatus">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                        </ng-select>
                    </ion-col>
                    <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="text-right">
                        <button type="button" class="add_btn fs-14" [style.background-color]="buttonColorName"
                            (click)="addNewSystemUnlock('Add',null)">
                            Add New</button>
                    </ion-col>
                </ion-row>
                <div class="tableCardBox mb-15 p-5">
                    <div class="table-container p-10">
                        <table class="hover mb-5 custom-table">
                            <thead>
                                <tr>
                                    <th class="fs-14 font_bold cl-black" style="width: 300px;">Employee Names</th>
                                    <th class="fs-14 font_bold cl-black">Unlock For Months</th>
                                    <th class="fs-14 font_bold cl-black">Relock Days</th>
                                    <th class="fs-14 font_bold cl-black">Relock Date</th>
                                    <th class="fs-14 font_bold cl-black">Created At</th>
                                    <th class="fs-14 font_bold cl-black">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of pmsUnlockStatusList;">
                                    <td class="fs-14 font_regular">
                                        <span *ngFor="let data of item.user;let isLast=last">
                                            {{ data.firstName }}&nbsp;{{ data.lastName }}{{isLast ? '' : ','}}</span>
                                    </td>
                                    <td class="fs-14 font_regular"><span
                                            *ngFor="let data of item.month;let isLast=last">
                                            {{sharedService.transform(data)}}{{isLast ? '' : ','}}
                                        </span>
                                    </td>
                                    <td class="fs-14 font_regular">{{item.relockDays}}</td>
                                    <td class="fs-14 font_regular">{{item.relockDate|date:'dd-MM-yyyy'}}</td>
                                    <td class="fs-14 font_regular">{{item.createdAt|date:'dd-MM-yyyy'}}</td>
                                    <td class="fs-14 font_regular">
                                        <img (click)="addNewSystemUnlock('Edit',item.id)" class="mr-5 cp imgdelete"
                                            src="././assets/icon/edit.png">
                                        &nbsp;&nbsp;
                                        <img (click)="deletePmsUnlockStatus(item.id)" class="cp imgdelete"
                                            src="././assets/icon/delete.png">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ion-row class="mb-5" *ngIf="pmsUnlockStatusList.length != 0">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
                            <ion-label class="fs-14 font_bold black_color">Showing {{showingCountPmsUnlockStatus}} to
                                {{showingOfCountPmsUnlockStatus}} of {{totalPmsUnlockStatus}} entries</ion-label>
                        </ion-col>
                    </ion-row>
                </div>
                <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-right display-end">
                        <ul class="dt_pagination">
                            <ion-row class="float-right pgintn">
                                <li class="active fs-16 font_regular">{{currentPageNumberOfPmsUnlockStatus}}</li>
                                <span class="fs-14 font_regular p-10">of {{totalPagesOfPmsUnlockStatus}}</span>
                                <li class="fs-24 cp" (click)="previousPagePmsUnlockStatus()"
                                    [ngClass]="{'disableBtn': currentPageNumberOfPmsUnlockStatus==1}">&lt;</li>
                                <li class="fs-24 cp" (click)="nextPagePmsUnlockStatus()"
                                    [ngClass]="{'disableBtn': currentPageNumberOfPmsUnlockStatus>= totalPagesOfPmsUnlockStatus}">
                                    &gt;</li>
                            </ion-row>
                        </ul>
                    </ion-col>
                </ion-row>
            </div>
        </div>
    </div>
</ion-content>